import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, mergeProps as _mergeProps, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, vShow as _vShow, withDirectives as _withDirectives, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  style: {"width":"400px"},
  class: "d-flex justify-center"
}
const _hoisted_2 = {
  style: {"width":"400px"},
  class: "d-flex justify-center"
}
const _hoisted_3 = { style: {"height":"calc(100vh - 157px)","overflow-y":"auto","border-top-left-radius":"25px","border-top-right-radius":"25px"} }
const _hoisted_4 = { style: {"color":"#e1be7a"} }
const _hoisted_5 = { class: "pb-0 pe-3 d-inline-block" }
const _hoisted_6 = { class: "ms-14 py-0 text-primary" }
const _hoisted_7 = { class: "pt-2" }
const _hoisted_8 = { class: "text-secondary" }
const _hoisted_9 = {
  class: "px-14 py-0",
  style: {"color":"#e1be7a"}
}
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = { class: "pl-2 pr-4" }
const _hoisted_12 = { class: "x-dense" }
const _hoisted_13 = { class: "text-end" }
const _hoisted_14 = { class: "text-end" }
const _hoisted_15 = { class: "text-end" }
const _hoisted_16 = { class: "text-end" }
const _hoisted_17 = {
  key: 0,
  class: "text-left"
}
const _hoisted_18 = { key: 1 }
const _hoisted_19 = { class: "text-left" }
const _hoisted_20 = { class: "text-left" }
const _hoisted_21 = { class: "text-left" }
const _hoisted_22 = { class: "text-left" }
const _hoisted_23 = { class: "text-left" }
const _hoisted_24 = { class: "text-right" }
const _hoisted_25 = { class: "text-right" }
const _hoisted_26 = {
  key: 1,
  class: "pl-2 pr-4"
}
const _hoisted_27 = { class: "x-dense" }
const _hoisted_28 = { class: "text-end" }
const _hoisted_29 = { class: "text-end" }
const _hoisted_30 = { class: "text-end" }
const _hoisted_31 = { class: "text-end" }
const _hoisted_32 = { class: "text-left" }
const _hoisted_33 = { class: "text-left" }
const _hoisted_34 = { class: "text-left" }
const _hoisted_35 = { class: "text-left" }
const _hoisted_36 = { class: "text-left" }
const _hoisted_37 = { class: "text-left" }
const _hoisted_38 = { class: "text-right" }
const _hoisted_39 = { class: "text-right" }
const _hoisted_40 = { class: "pl-2 pr-4" }
const _hoisted_41 = { class: "x-dense" }
const _hoisted_42 = { class: "text-end" }
const _hoisted_43 = { class: "text-end" }
const _hoisted_44 = { class: "text-end" }
const _hoisted_45 = { class: "text-end" }
const _hoisted_46 = { class: "text-left" }
const _hoisted_47 = { class: "text-left" }
const _hoisted_48 = { class: "text-left" }
const _hoisted_49 = { class: "text-left" }
const _hoisted_50 = { class: "text-left" }
const _hoisted_51 = { class: "text-left" }
const _hoisted_52 = { class: "text-right" }
const _hoisted_53 = { class: "text-right" }
const _hoisted_54 = {
  key: 0,
  class: "d-flex px-4 pb-4 justify-center text-primary"
}
const _hoisted_55 = { class: "x-dense" }
const _hoisted_56 = { class: "text-end" }
const _hoisted_57 = {
  key: 0,
  class: "text-left"
}
const _hoisted_58 = {
  key: 1,
  class: "text-left"
}
const _hoisted_59 = {
  key: 2,
  class: "text-center"
}
const _hoisted_60 = {
  key: 3,
  class: "text-center"
}
const _hoisted_61 = {
  key: 4,
  class: "text-right"
}
const _hoisted_62 = {
  key: 5,
  class: "text-right"
}
const _hoisted_63 = {
  key: 6,
  class: "text-right"
}
const _hoisted_64 = {
  key: 7,
  class: "text-right"
}
const _hoisted_65 = {
  key: 8,
  class: "text-center"
}
const _hoisted_66 = { class: "pl-4" }
const _hoisted_67 = { class: "pl-4" }
const _hoisted_68 = { class: "pl-4" }
const _hoisted_69 = { class: "pl-4" }
const _hoisted_70 = { class: "pl-4" }
const _hoisted_71 = { class: "pl-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn_back = _resolveComponent("v-btn-back")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_btn_prev = _resolveComponent("v-btn-prev")!
  const _component_v_btn_next = _resolveComponent("v-btn-next")!
  const _component_v_btn_icon = _resolveComponent("v-btn-icon")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_card_subtitle = _resolveComponent("v-card-subtitle")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn_warning = _resolveComponent("v-btn-warning")!
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!
  const _component_oss_data_table = _resolveComponent("oss-data-table")!
  const _component_v_select_filled = _resolveComponent("v-select-filled")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_v_list_item_subtitle = _resolveComponent("v-list-item-subtitle")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_oss_date_picker_filled = _resolveComponent("oss-date-picker-filled")!
  const _component_GeneralLedger = _resolveComponent("GeneralLedger")!
  const _component_v_expand_transition = _resolveComponent("v-expand-transition")!
  const _component_AuditConnectedAcrDocuments = _resolveComponent("AuditConnectedAcrDocuments")!
  const _component_AuditConnectedAcrResults = _resolveComponent("AuditConnectedAcrResults")!
  const _component_CheckFixedAssetsCutPreviousImport = _resolveComponent("CheckFixedAssetsCutPreviousImport")!
  const _component_GetEmptyDocumentsTable = _resolveComponent("GetEmptyDocumentsTable")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_Chat = _resolveComponent("Chat")!
  const _component_AuditCheckDocumentsManager = _resolveComponent("AuditCheckDocumentsManager")!
  const _component_UsersActivitiesHistory = _resolveComponent("UsersActivitiesHistory")!
  const _component_AuditDeleteAuditCheckResultDialog = _resolveComponent("AuditDeleteAuditCheckResultDialog")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, {
    "grid-list-md": "",
    fluid: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, { class: "d-flex justify-space-between mb-1" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, { cols: "6" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, { "no-gutters": "" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, {
                    cols: "1",
                    class: "d-flex align-center justify-center"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_btn_back, {
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({ name: 'auditReport' })))
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, { cols: "11" }, {
                    default: _withCtx(() => [
                      _createElementVNode("h2", null, [
                        _cache[77] || (_cache[77] = _createTextVNode(" Reprise des immobilisations et amortissements antérieurs ")),
                        _createVNode(_component_v_tooltip, { "location:q": "bottom" }, {
                          activator: _withCtx(({ props }) => [
                            _createVNode(_component_v_icon, _mergeProps({ color: "secondary" }, props, { class: "ml-2" }), {
                              default: _withCtx(() => _cache[71] || (_cache[71] = [
                                _createTextVNode(" $oss-help ")
                              ])),
                              _: 2
                            }, 1040)
                          ]),
                          default: _withCtx(() => [
                            _cache[72] || (_cache[72] = _createElementVNode("h4", null, "Actions effectuées :", -1)),
                            _cache[73] || (_cache[73] = _createElementVNode("h4", null, " Contre-passation des reports à nouveaux des comptes d'immobilisations et d'amortissements ", -1)),
                            _cache[74] || (_cache[74] = _createElementVNode("h4", null, "Création des lignes d'immobilisations détaillées", -1)),
                            _cache[75] || (_cache[75] = _createElementVNode("h4", null, " Génération des tableaux d'amortissements complets, conformément à la situation au 31/12/N-1 ", -1)),
                            _cache[76] || (_cache[76] = _createElementVNode("h4", null, "Comptabilisation des dotations mensuelles encore à courir", -1))
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_row, { "no-gutters": "" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { cols: "1" }),
                  _createVNode(_component_v_col, { cols: "10" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(`Statut : ${_ctx.checkStatus}`), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, { cols: "6" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, {
                "no-gutters": "",
                class: "d-flex justify-end align-center"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_tooltip, {
                    location: "bottom",
                    text: "Lier un document"
                  }, {
                    activator: _withCtx(({ props }) => [
                      _createVNode(_component_v_btn, _mergeProps({
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.dialogAuditCheckDocumentsManager = true))
                      }, props, {
                        size: "x-small",
                        icon: "$oss-upload",
                        class: "mx-1"
                      }), null, 16)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_tooltip, {
                    location: "bottom",
                    text: "Message"
                  }, {
                    activator: _withCtx(({ props }) => [
                      _createVNode(_component_v_btn, _mergeProps({
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.openChat = !_ctx.openChat))
                      }, props, {
                        size: "x-small",
                        icon: "$oss-chat",
                        class: "mx-1"
                      }), null, 16)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_btn, {
                    disabled: 
                            _ctx.closedPeriod || _ctx.validated || _ctx.loading || _ctx.dataLoading || !_ctx.accountingPeriod
                        ,
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.storeComments())),
                    size: "small",
                    class: "mx-1"
                  }, {
                    default: _withCtx(() => _cache[78] || (_cache[78] = [
                      _createTextVNode(" Enregistrer ")
                    ])),
                    _: 1
                  }, 8, ["disabled"]),
                  _createVNode(_component_v_btn, {
                    disabled: _ctx.validationDisabled,
                    onClick: _cache[4] || (_cache[4] = ($event: any) => {
                            _ctx.validated = !_ctx.validated;
                            _ctx.storeComments();
                        }),
                    "data-cy": "CheckFixedAssetsCutPrevious-valid",
                    size: "small",
                    class: "mx-1"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.validated ? "Invalider" : "Valider"), 1)
                    ]),
                    _: 1
                  }, 8, ["disabled"]),
                  (_ctx.isEnableReview)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _cache[79] || (_cache[79] = _createElementVNode("div", { style: {"border-right":"2px solid black","width":"2px","height":"25px","margin":"0 4px"} }, null, -1)),
                        _createVNode(_component_v_icon, {
                          disabled: 
                                _ctx.reviewed === 1 ||
                                !_ctx.isEnableReview ||
                                !_ctx.validated ||
                                _ctx.loading ||
                                _ctx.dataLoading
                            ,
                          size: "small",
                          icon: "$fa-thumbs-up",
                          color: "primary",
                          class: "mx-1",
                          onClick: _cache[5] || (_cache[5] = ($event: any) => {
                                _ctx.reviewed = 1;
                                _ctx.storeComments('REVIEW');
                            })
                        }, null, 8, ["disabled"]),
                        _createVNode(_component_v_icon, {
                          disabled: 
                                _ctx.reviewed === -1 ||
                                !_ctx.isEnableReview ||
                                !_ctx.validated ||
                                _ctx.loading ||
                                _ctx.dataLoading
                            ,
                          size: "small",
                          icon: "$fa-thumbs-down",
                          color: "primary",
                          class: "mx-1",
                          onClick: _cache[6] || (_cache[6] = ($event: any) => {
                                _ctx.reviewed = -1;
                                _ctx.storeComments('REVIEW');
                            })
                        }, null, 8, ["disabled"]),
                        _cache[80] || (_cache[80] = _createElementVNode("div", { style: {"border-right":"2px solid black","width":"1px","height":"25px","margin":"0 4px"} }, null, -1))
                      ], 64))
                    : _createCommentVNode("", true),
                  _createVNode(_component_v_tooltip, { location: "bottom" }, {
                    activator: _withCtx(({ props }) => [
                      _createVNode(_component_v_btn_prev, _mergeProps(props, {
                        disabled: !_ctx.previousControl,
                        onClick: _cache[7] || (_cache[7] = ($event: any) => {
                                    _ctx.reviewed = 0;
                                    _ctx.openChat = false;
                                    _ctx.goToPreviousControl();
                                })
                      }), null, 16, ["disabled"])
                    ]),
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_1, " Contrôle précédent : " + _toDisplayString(_ctx.previousControl && _ctx.previousControl.title
                                    ? _ctx.previousControl.title
                                    : ""), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_tooltip, { location: "bottom" }, {
                    activator: _withCtx(({ props }) => [
                      _createVNode(_component_v_btn_next, _mergeProps(props, {
                        onClick: _cache[8] || (_cache[8] = ($event: any) => {
                                    _ctx.reviewed = 0;
                                    _ctx.openChat = false;
                                    _ctx.goToNextControl();
                                }),
                        disabled: !_ctx.nextControl
                      }), null, 16, ["disabled"])
                    ]),
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_2, " Contrôle suivant : " + _toDisplayString(_ctx.nextControl && _ctx.nextControl.title ? _ctx.nextControl.title : ""), 1)
                    ]),
                    _: 1
                  }),
                  _cache[87] || (_cache[87] = _createElementVNode("div", { style: {"border-right":"2px solid black","width":"1px","height":"25px","margin":"0 4px"} }, null, -1)),
                  _createVNode(_component_v_menu, { "offset-y": "" }, {
                    activator: _withCtx(({ props }) => [
                      _createVNode(_component_v_btn_icon, _mergeProps({ icon: "$dots_vertical" }, props, {
                        class: "mx-1",
                        color: "secondary"
                      }), null, 16)
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_v_list, { nav: "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_list_item, {
                            onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.displayActivityDialog = true))
                          }, {
                            append: _withCtx(() => [
                              _createVNode(_component_v_icon, null, {
                                default: _withCtx(() => _cache[82] || (_cache[82] = [
                                  _createTextVNode("$oss-activity")
                                ])),
                                _: 1
                              })
                            ]),
                            default: _withCtx(() => [
                              _createVNode(_component_v_list_item_title, null, {
                                default: _withCtx(() => _cache[81] || (_cache[81] = [
                                  _createTextVNode("Afficher l'activité")
                                ])),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          (!_ctx.showDeleteAcrBtnIfRecovery)
                            ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                key: 0,
                                location: "bottom"
                              }, {
                                activator: _withCtx(({ props }) => [
                                  _createElementVNode("div", _mergeProps({ "no-gutters": "" }, props), [
                                    _createVNode(_component_v_list_item, {
                                      "no-gutters": "",
                                      disabled: ""
                                    }, {
                                      append: _withCtx(() => [
                                        _createVNode(_component_v_icon, { size: "small" }, {
                                          default: _withCtx(() => _cache[84] || (_cache[84] = [
                                            _createTextVNode(" $oss-trash ")
                                          ])),
                                          _: 1
                                        })
                                      ]),
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_list_item_title, null, {
                                          default: _withCtx(() => _cache[83] || (_cache[83] = [
                                            _createTextVNode(" Supprimer la reprise ")
                                          ])),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ], 16)
                                ]),
                                default: _withCtx(() => [
                                  _createElementVNode("span", null, _toDisplayString(_ctx.showDeleteAcrBtnTooltipMessage), 1)
                                ]),
                                _: 1
                              }))
                            : (_openBlock(), _createBlock(_component_v_list_item, {
                                key: 1,
                                "no-gutters": "",
                                onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.deleteAuditCheckResultDialog = true))
                              }, {
                                append: _withCtx(() => [
                                  _createVNode(_component_v_icon, null, {
                                    default: _withCtx(() => _cache[86] || (_cache[86] = [
                                      _createTextVNode("$oss-trash")
                                    ])),
                                    _: 1
                                  })
                                ]),
                                default: _withCtx(() => [
                                  _createVNode(_component_v_list_item_title, null, {
                                    default: _withCtx(() => _cache[85] || (_cache[85] = [
                                      _createTextVNode(" Supprimer la reprise ")
                                    ])),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_3, [
        (_ctx.loading)
          ? (_openBlock(), _createBlock(_component_v_card, {
              key: 0,
              elevation: "0",
              style: {"background-color":"#ffffff","border-radius":"25px","margin-top":"10px"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_title, { class: "pa-4 d-flex justify-center" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_progress_circular, {
                      indeterminate: "",
                      class: "mr-3"
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : (_ctx.recoveryFinished && _ctx.results && _ctx.results[0] && _ctx.results[0].date)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createVNode(_component_v_card_title, { class: "pl-14 pr-0 py-2" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, { "no-gutters": "" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, { cols: "12" }, {
                          default: _withCtx(() => [
                            _createElementVNode("h3", _hoisted_4, " Reprise des amortissements 'avant bobbee' effectuée le " + _toDisplayString(_ctx.formatDate(_ctx.results[0].date)), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                (_ctx.errorsUploadDocument.size)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createElementVNode("div", _hoisted_5, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errorsUploadDocument, ([key, value]) => {
                          return (_openBlock(), _createElementBlock("span", {
                            key: key,
                            class: "pb-0 d-inline-block"
                          }, [
                            _createElementVNode("h4", _hoisted_6, _toDisplayString(_ctx.$t("audit.cutPrevious." + key)), 1),
                            _createVNode(_component_v_row, {
                              "no-gutters": "",
                              class: "ms-14"
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(value, (fixedAssetWording, index) => {
                                  return (_openBlock(), _createBlock(_component_v_col, {
                                    cols: "12",
                                    key: index
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(" - " + _toDisplayString(fixedAssetWording), 1)
                                    ]),
                                    _: 2
                                  }, 1024))
                                }), 128))
                              ]),
                              _: 2
                            }, 1024)
                          ]))
                        }), 128))
                      ]),
                      _cache[88] || (_cache[88] = _createElementVNode("h4", { class: "pb-0 ms-14 text-error" }, " Vous pouvez corriger les imports de documents en supprimant la reprise et en la recréant après avoir corriger les soucis. Ou en ajoutant les documents manquants manuellement. ", -1))
                    ], 64))
                  : _createCommentVNode("", true)
              ], 64))
            : (_ctx.currentPeriodIsFirstPeriod)
              ? (_openBlock(), _createBlock(_component_v_row, {
                  key: 2,
                  "no-gutters": ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, { cols: "8" }, {
                      default: _withCtx(() => _cache[89] || (_cache[89] = [
                        _createElementVNode("h3", {
                          style: {"color":"#e1be7a"},
                          class: "pt-2 pl-2"
                        }, " Premier exercice d'activité : pas de reprise d'immobilisations ", -1)
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : (_ctx.noData)
                ? (_openBlock(), _createBlock(_component_v_row, {
                    key: 3,
                    "no-gutters": ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, null, {
                        default: _withCtx(() => _cache[90] || (_cache[90] = [
                          _createElementVNode("h3", {
                            style: {"color":"#e1be7a"},
                            class: "pt-2 pl-2"
                          }, "Aucune donnée", -1)
                        ])),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : (_ctx.closedPeriod)
                  ? (_openBlock(), _createBlock(_component_v_row, {
                      key: 4,
                      "no-gutters": "",
                      class: "d-flex flex-column justify-center align-center mb-3"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, {
                          class: "mr-2 mb-1",
                          size: "large"
                        }, {
                          default: _withCtx(() => _cache[91] || (_cache[91] = [
                            _createTextVNode(" $oss-warning ")
                          ])),
                          _: 1
                        }),
                        _cache[92] || (_cache[92] = _createElementVNode("h3", null, "Période clôturée, aucune action possible", -1))
                      ]),
                      _: 1
                    }))
                  : (!_ctx.recoveryFinished && (!_ctx.N_1AccountingPeriod || !_ctx.N_1AccountingPeriod.id))
                    ? (_openBlock(), _createBlock(_component_v_row, {
                        key: 5,
                        "no-gutters": ""
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, {
                            cols: "12",
                            style: {"color":"#e1be7a"}
                          }, {
                            default: _withCtx(() => _cache[93] || (_cache[93] = [
                              _createElementVNode("h3", null, "Attention : pas d'exercice N-1, aucune action possible", -1)
                            ])),
                            _: 1
                          }),
                          _createVNode(_component_v_col, { cols: "12" }, {
                            default: _withCtx(() => _cache[94] || (_cache[94] = [
                              _createElementVNode("h3", { style: {"color":"#e1be7a"} }, " S'il existe, pour le créer et clôturer : Mon dossier - Exercices - Ajouter (attention à cocher \"exercice clôturé) ", -1)
                            ])),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : (!_ctx.recoveryFinished && _ctx.N_1AccountingPeriod && !_ctx.N_1AccountingPeriod.closed)
                      ? (_openBlock(), _createBlock(_component_v_row, {
                          key: 6,
                          "no-gutters": "",
                          style: {"color":"#e1be7a"}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, { cols: "1" }),
                            _createVNode(_component_v_col, { cols: "10" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_row, { "no-gutters": "" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, { cols: "12" }, {
                                      default: _withCtx(() => _cache[95] || (_cache[95] = [
                                        _createElementVNode("h3", null, "Attention : N-1 n'est pas clôturé, aucune action possible", -1)
                                      ])),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_row, { "no-gutters": "" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, { cols: "12" }, {
                                      default: _withCtx(() => _cache[96] || (_cache[96] = [
                                        _createElementVNode("h3", null, " Pour clôturer Mon dossier - Exercices - N-1 - Modifier - Exercice clôturé ", -1)
                                      ])),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : (!_ctx.companyFirstPeriod.start)
                        ? (_openBlock(), _createBlock(_component_v_row, {
                            key: 7,
                            "no-gutters": ""
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_col, { cols: "1" }),
                              _createVNode(_component_v_col, {
                                cols: "10",
                                class: "d-flex justify-center mt-5"
                              }, {
                                default: _withCtx(() => _cache[97] || (_cache[97] = [
                                  _createElementVNode("h3", { class: "text-primary" }, " Afin de calculer correctement toutes les reprises il est nécessaire de renseigner dans \"Mon dossier\" - \"Entreprise\" - \"Régimes d'imposition\" les dates de début d'activité et de fin du premier exercice d'activité ", -1)
                                ])),
                                _: 1
                              }),
                              _createVNode(_component_v_col, { cols: "1" })
                            ]),
                            _: 1
                          }))
                        : (_ctx.accountingPeriod)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 8 }, [
                              _createVNode(_component_v_card_subtitle, { class: "px-0 pt-2 pb-4" }, {
                                default: _withCtx(() => _cache[98] || (_cache[98] = [
                                  _createElementVNode("h3", { class: "px-14 text-primary" }, " Attention : la reprise automatique est actuellement fonctionnelle avec les amortissements linéaires uniquement ", -1)
                                ])),
                                _: 1
                              }),
                              _createVNode(_component_v_card_title, { class: "pl-14 pr-0 py-2" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_row, {
                                    "no-gutters": "",
                                    class: "d-flex align-center"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_col, { cols: "auto" }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("h3", _hoisted_7, " Tableau d'amortissements à reprendre au " + _toDisplayString(_ctx.formatDate(_ctx.selectedDate)), 1)
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_spacer),
                                      _createVNode(_component_v_col, {
                                        cols: "auto",
                                        class: "px-4"
                                      }, {
                                        default: _withCtx(() => [
                                          (_ctx.someDecliningDepreciationError)
                                            ? (_openBlock(), _createBlock(_component_v_btn_warning, {
                                                key: 0,
                                                size: "x-small",
                                                color: "red",
                                                onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.someDecliningDepreciationErrorDialog = true))
                                              }))
                                            : _createCommentVNode("", true),
                                          (
                                    _ctx.changeFixedAssetsAccountableAccountGap ||
                                    _ctx.changeDepreciationAccountableAccountGap ||
                                    _ctx.changeDerogationAccountableAccountGap
                                )
                                            ? (_openBlock(), _createBlock(_component_v_btn_warning, {
                                                key: 1,
                                                size: "x-small",
                                                color: "red",
                                                onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.changeAccountableAccountsGapsDialog = true))
                                              }))
                                            : _createCommentVNode("", true),
                                          (
                                    _ctx.errorsOnFullDepreciatedFixedAssets &&
                                    _ctx.errorsOnFullDepreciatedFixedAssets.length
                                )
                                            ? (_openBlock(), _createBlock(_component_v_btn_warning, {
                                                key: 2,
                                                size: "x-small",
                                                color: "red",
                                                onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.fullDepreciatedFixedAssetsDialog = true))
                                              }))
                                            : (_ctx.gapToAffect)
                                              ? (_openBlock(), _createBlock(_component_v_btn_warning, {
                                                  key: 3,
                                                  size: "x-small",
                                                  color: "red",
                                                  onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.fullGapsDialog = true))
                                                }))
                                              : (_ctx.gap68LOnRegulN_1Errors && _ctx.gap68LOnRegulN_1Errors.length)
                                                ? (_openBlock(), _createBlock(_component_v_btn_warning, {
                                                    key: 4,
                                                    size: "x-small",
                                                    color: "red",
                                                    onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.gap68LOnRegulN_1ErrorsDialog = true))
                                                  }))
                                                : _createCommentVNode("", true),
                                          (_ctx.importConditions)
                                            ? (_openBlock(), _createBlock(_component_v_btn, {
                                                key: 5,
                                                loading: 
                                    _ctx.importLoading || _ctx.storeFixedAssetsLoading || _ctx.storeCutsLoading
                                ,
                                                onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.importFunction())),
                                                size: "small",
                                                "data-cy": "CheckFixedAssetsCutPrevious-importer"
                                              }, {
                                                default: _withCtx(() => _cache[99] || (_cache[99] = [
                                                  _createTextVNode(" Importer ")
                                                ])),
                                                _: 1
                                              }, 8, ["loading"]))
                                            : (_ctx.cutConditions)
                                              ? (_openBlock(), _createBlock(_component_v_btn, {
                                                  key: 6,
                                                  size: "small",
                                                  onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.cutPrevious()))
                                                }, {
                                                  default: _withCtx(() => [
                                                    _cache[100] || (_cache[100] = _createTextVNode(" Découper les reports à nouveau ")),
                                                    _createVNode(_component_v_icon, { icon: "$cut" })
                                                  ]),
                                                  _: 1
                                                }))
                                              : (_ctx.depreciateConditions)
                                                ? (_openBlock(), _createBlock(_component_v_btn, {
                                                    key: 7,
                                                    loading: _ctx.alsToDepreciateLoopLoading,
                                                    size: "small",
                                                    onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.alsToDepreciateLoop()))
                                                  }, {
                                                    loader: _withCtx(() => [
                                                      _createVNode(_component_v_progress_linear, {
                                                        rounded: "",
                                                        color: "white",
                                                        class: "mx-2",
                                                        height: "18",
                                                        "model-value": 
                                            (100 * _ctx.alIndex) / (_ctx.als2ToDepreciateLength - 1)
                                        
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createElementVNode("strong", _hoisted_8, _toDisplayString(_ctx.alIndex) + " / " + _toDisplayString(_ctx.als2ToDepreciateLength), 1)
                                                        ]),
                                                        _: 1
                                                      }, 8, ["model-value"])
                                                    ]),
                                                    default: _withCtx(() => [
                                                      _cache[101] || (_cache[101] = _createTextVNode(" Générer les tableaux d'amortissements et les écritures "))
                                                    ]),
                                                    _: 1
                                                  }, 8, ["loading"]))
                                                : _createCommentVNode("", true)
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              (_ctx.errorMessages.length)
                                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.errorMessages, (errorMessage, index) => {
                                    return (_openBlock(), _createBlock(_component_v_card_title, {
                                      key: index,
                                      class: "pb-0"
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("h4", _hoisted_9, _toDisplayString(errorMessage), 1)
                                      ]),
                                      _: 2
                                    }, 1024))
                                  }), 128))
                                : (_ctx.fixedAssetsFile && _ctx.fixedAssetsFile.length)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                      (_ctx.someDecliningDepreciationError)
                                        ? (_openBlock(), _createBlock(_component_oss_dialog, {
                                            key: 0,
                                            modelValue: _ctx.someDecliningDepreciationErrorDialog,
                                            "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.someDecliningDepreciationErrorDialog) = $event)),
                                            withoutHeader: "true",
                                            onClose: _cache[20] || (_cache[20] = ($event: any) => (_ctx.closeDialog())),
                                            "min-width": "90vw"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_alert, {
                                                border: "start",
                                                "border-color": "red",
                                                class: "py-0 mb-0"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createElementVNode("div", { innerHTML: _ctx.someDecliningDepreciationErrorMessage }, null, 8, _hoisted_10)
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          }, 8, ["modelValue"]))
                                        : _createCommentVNode("", true),
                                      (!_ctx.isEmpty(_ctx.gaps) || _ctx.gap68LOnRegulN_1ErrorsDialog)
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                            (
                                !_ctx.someDecliningDepreciationError &&
                                (_ctx.changeFixedAssetsAccountableAccountGap ||
                                    _ctx.changeDepreciationAccountableAccountGap ||
                                    _ctx.changeDerogationAccountableAccountGap)
                            )
                                              ? (_openBlock(), _createBlock(_component_oss_dialog, {
                                                  key: 0,
                                                  modelValue: _ctx.changeAccountableAccountsGapsDialog,
                                                  "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.changeAccountableAccountsGapsDialog) = $event)),
                                                  withoutHeader: "true",
                                                  "max-height": "100%",
                                                  validDisabled: _ctx.disabledChangeFixedAssetsAccountableAccountGap,
                                                  validTitle: 'Valider la modification des comptes comptables',
                                                  onClose: _cache[26] || (_cache[26] = ($event: any) => (_ctx.changeAccountableAccountsGapsDialog = false)),
                                                  onValid: _cache[27] || (_cache[27] = ($event: any) => (_ctx.storeAccountableAccountsChanges())),
                                                  "min-width": "100vw"
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_window, {
                                                      modelValue: _ctx.changeAccountableAccountsGapStep,
                                                      "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.changeAccountableAccountsGapStep) = $event))
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_v_window_item, { value: 'changeAAList' }, {
                                                          default: _withCtx(() => [
                                                            (_ctx.changeFixedAssetsAccountableAccountGap)
                                                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                                  _createElementVNode("div", _hoisted_11, [
                                                                    _cache[105] || (_cache[105] = _createElementVNode("h2", { class: "pb-2" }, " Aucun écart global sur les COMPTES D'IMMOBILISATION, il suffit de modifier les comptes comptables ", -1)),
                                                                    (_ctx.gap_fixedAssetsAccountableAccount)
                                                                      ? (_openBlock(), _createBlock(_component_v_row, {
                                                                          key: 0,
                                                                          "no-gutters": ""
                                                                        }, {
                                                                          default: _withCtx(() => [
                                                                            _createVNode(_component_v_col, {
                                                                              cols: "4",
                                                                              class: "d-flex align-center"
                                                                            }, {
                                                                              default: _withCtx(() => _cache[102] || (_cache[102] = [
                                                                                _createElementVNode("h4", null, "Ecarts sur le grand livre :", -1)
                                                                              ])),
                                                                              _: 1
                                                                            }),
                                                                            _createVNode(_component_v_col, { cols: "8" }, {
                                                                              default: _withCtx(() => [
                                                                                _createVNode(_component_oss_data_table, {
                                                                                  headers: _ctx.gapsGlHeaders,
                                                                                  items: 
                                                            _ctx.gap_fixedAssetsAccountableAccount
                                                                .gapData.glWithoutImportResume
                                                        ,
                                                                                  striped: true,
                                                                                  "x-dense": true,
                                                                                  class: "table"
                                                                                }, {
                                                                                  item: _withCtx((props) => [
                                                                                    _createElementVNode("tr", null, [
                                                                                      _createElementVNode("td", {
                                                                                        class: _normalizeClass(
                                                                        'text-left ' +
                                                                        _ctx.glGapColor(props.item.gap)
                                                                    )
                                                                                      }, _toDisplayString(props.item.aaName || ""), 3),
                                                                                      _createElementVNode("td", {
                                                                                        class: _normalizeClass(
                                                                        'text-right ' +
                                                                        _ctx.glGapColor(props.item.gap)
                                                                    )
                                                                                      }, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                                            props.item.glSum,
                                                                            { currency: "" },
                                                                        )), 3),
                                                                                      _createElementVNode("td", {
                                                                                        class: _normalizeClass(
                                                                        'text-right ' +
                                                                        _ctx.glGapColor(props.item.gap)
                                                                    )
                                                                                      }, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                                            props.item
                                                                                .alreadyImportedSum,
                                                                            { currency: "" },
                                                                        )), 3),
                                                                                      _createElementVNode("td", {
                                                                                        class: _normalizeClass(
                                                                        'text-right ' +
                                                                        _ctx.glGapColor(props.item.gap)
                                                                    )
                                                                                      }, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                                            props.item.importedSum,
                                                                            { currency: "" },
                                                                        )), 3),
                                                                                      _createElementVNode("td", {
                                                                                        class: _normalizeClass(
                                                                        'text-right ' +
                                                                        _ctx.glGapColor(props.item.gap)
                                                                    )
                                                                                      }, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                                            props.item.gap,
                                                                            { currency: "" },
                                                                        )), 3)
                                                                                    ])
                                                                                  ]),
                                                                                  "body.append": _withCtx(() => [
                                                                                    _createElementVNode("tr", _hoisted_12, [
                                                                                      _cache[103] || (_cache[103] = _createElementVNode("th", { class: "text-start" }, "Totaux", -1)),
                                                                                      _createElementVNode("th", _hoisted_13, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                                            _ctx.sumColumn(
                                                                                _ctx.gap_fixedAssetsAccountableAccount
                                                                                    .gapData
                                                                                    .glWithoutImportResume,
                                                                                "glSum",
                                                                            ),
                                                                            { currency: "" },
                                                                        )), 1),
                                                                                      _createElementVNode("th", _hoisted_14, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                                            _ctx.sumColumn(
                                                                                _ctx.gap_fixedAssetsAccountableAccount
                                                                                    .gapData
                                                                                    .glWithoutImportResume,
                                                                                "alreadyImportedSum",
                                                                            ),
                                                                            { currency: "" },
                                                                        )), 1),
                                                                                      _createElementVNode("th", _hoisted_15, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                                            _ctx.sumColumn(
                                                                                _ctx.gap_fixedAssetsAccountableAccount
                                                                                    .gapData
                                                                                    .glWithoutImportResume,
                                                                                "importedSum",
                                                                            ),
                                                                            { currency: "" },
                                                                        )), 1),
                                                                                      _createElementVNode("th", _hoisted_16, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                                            _ctx.sumColumn(
                                                                                _ctx.gap_fixedAssetsAccountableAccount
                                                                                    .gapData
                                                                                    .glWithoutImportResume,
                                                                                "gap",
                                                                            ),
                                                                            { currency: "" },
                                                                        )), 1)
                                                                                    ])
                                                                                  ]),
                                                                                  _: 1
                                                                                }, 8, ["headers", "items"])
                                                                              ]),
                                                                              _: 1
                                                                            })
                                                                          ]),
                                                                          _: 1
                                                                        }))
                                                                      : _createCommentVNode("", true),
                                                                    (_ctx.gap_fixedAssetsAccountableAccount)
                                                                      ? (_openBlock(), _createBlock(_component_v_row, {
                                                                          key: 1,
                                                                          "no-gutters": "",
                                                                          class: "pt-4 pb-2"
                                                                        }, {
                                                                          default: _withCtx(() => [
                                                                            (
                                                        _ctx.gap_fixedAssetsAccountableAccount.gapData &&
                                                        !_ctx.gap_fixedAssetsAccountableAccount.gapData
                                                            .sumGap
                                                    )
                                                                              ? (_openBlock(), _createBlock(_component_v_col, { key: 0 }, {
                                                                                  default: _withCtx(() => _cache[104] || (_cache[104] = [
                                                                                    _createElementVNode("h3", { class: "py-2" }, " Détails des immobilisations importées dont les comptes comptables ne trouvent pas de correspondance dans le grand livre : ", -1)
                                                                                  ])),
                                                                                  _: 1
                                                                                }))
                                                                              : _createCommentVNode("", true)
                                                                          ]),
                                                                          _: 1
                                                                        }))
                                                                      : _createCommentVNode("", true)
                                                                  ]),
                                                                  _createVNode(_component_oss_data_table, {
                                                                    headers: _ctx.gapsImportedLinesHeaders2,
                                                                    items: 
                                                _ctx.gap_fixedAssetsAccountableAccount.gapData
                                                    .importLinesWithoutGl
                                            ,
                                                                    striped: true,
                                                                    "x-dense": true,
                                                                    "virtual-scroll": true,
                                                                    class: "table"
                                                                  }, {
                                                                    item: _withCtx((props) => [
                                                                      _createElementVNode("tr", null, [
                                                                        _createElementVNode("td", {
                                                                          class: "text-left",
                                                                          style: _normalizeStyle(
                                                            _ctx.gapSelectColor(
                                                                props.item,
                                                                'aaNameFixedAsset',
                                                            )
                                                        )
                                                                        }, _toDisplayString(props.item.aaNameFixedAsset || ""), 5),
                                                                        (
                                                            _ctx.gap_fixedAssetsAccountableAccount &&
                                                            _ctx.gap_fixedAssetsAccountableAccount.gapData &&
                                                            _ctx.gap_fixedAssetsAccountableAccount
                                                                .gapData
                                                                .toProposeGlAccountableAccounts
                                                        )
                                                                          ? (_openBlock(), _createElementBlock("td", _hoisted_17, [
                                                                              _createVNode(_component_v_select_filled, {
                                                                                modelValue: 
                                                                props.item.changedAccountableAccount
                                                            ,
                                                                                "onUpdate:modelValue": [
                                                                                  ($event: any) => ((
                                                                props.item.changedAccountableAccount
                                                            ) = $event),
                                                                                  _cache[21] || (_cache[21] = ($event: any) => (
                                                                _ctx.changeNoGapFixedAssetAccountableAccounts(
                                                                    'fixedAssets',
                                                                )
                                                            ))
                                                                                ],
                                                                                items: 
                                                                _ctx.gap_fixedAssetsAccountableAccount
                                                                    .gapData
                                                                    .toProposeGlAccountableAccounts
                                                            ,
                                                                                "item-value": "value",
                                                                                "hide-details": true,
                                                                                density: "compact",
                                                                                "item-title": (item) => item.text
                                                                              }, null, 8, ["modelValue", "onUpdate:modelValue", "items", "item-title"])
                                                                            ]))
                                                                          : (_openBlock(), _createElementBlock("td", _hoisted_18)),
                                                                        _createElementVNode("td", _hoisted_19, _toDisplayString(props.item.aaNameDepreciation || ""), 1),
                                                                        _createElementVNode("td", _hoisted_20, _toDisplayString(props.item.date || ""), 1),
                                                                        _createElementVNode("td", _hoisted_21, _toDisplayString(props.item.wording || ""), 1),
                                                                        _createElementVNode("td", _hoisted_22, _toDisplayString(props.item.type || ""), 1),
                                                                        _createElementVNode("td", _hoisted_23, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                                props.item.rate,
                                                                { currency: "" },
                                                            )), 1),
                                                                        _createElementVNode("td", _hoisted_24, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                                props.item.alNetAmountSigned,
                                                                { currency: "" },
                                                            )), 1),
                                                                        _createElementVNode("td", _hoisted_25, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                                props.item
                                                                    .previousDepreciationAmountSigned,
                                                                { currency: "" },
                                                            )), 1)
                                                                      ])
                                                                    ]),
                                                                    _: 1
                                                                  }, 8, ["headers", "items"])
                                                                ], 64))
                                                              : (_ctx.changeDepreciationAccountableAccountGap)
                                                                ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                                                                    _cache[109] || (_cache[109] = _createElementVNode("h2", { class: "pb-2" }, " Aucun écart global sur les COMPTES D'AMORTISSEMENT LINEAIRES, il suffit de modifier les comptes comptables ", -1)),
                                                                    (_ctx.gap_depreciationAccountableAccount)
                                                                      ? (_openBlock(), _createBlock(_component_v_row, {
                                                                          key: 0,
                                                                          "no-gutters": ""
                                                                        }, {
                                                                          default: _withCtx(() => [
                                                                            _createVNode(_component_v_col, {
                                                                              cols: "4",
                                                                              class: "d-flex align-center"
                                                                            }, {
                                                                              default: _withCtx(() => _cache[106] || (_cache[106] = [
                                                                                _createElementVNode("h4", null, "Ecarts sur le grand livre :", -1)
                                                                              ])),
                                                                              _: 1
                                                                            }),
                                                                            _createVNode(_component_v_col, { cols: "8" }, {
                                                                              default: _withCtx(() => [
                                                                                _createVNode(_component_oss_data_table, {
                                                                                  headers: _ctx.gapsGlHeaders,
                                                                                  items: 
                                                            _ctx.gap_depreciationAccountableAccount
                                                                .gapData.glWithoutImportResume
                                                        ,
                                                                                  striped: true,
                                                                                  "x-dense": true,
                                                                                  class: "table"
                                                                                }, {
                                                                                  item: _withCtx((props) => [
                                                                                    _createElementVNode("tr", null, [
                                                                                      _createElementVNode("td", {
                                                                                        class: "text-left",
                                                                                        style: _normalizeStyle(
                                                                        _ctx.glGapColor(props.item.gap)
                                                                    )
                                                                                      }, _toDisplayString(props.item.aaName || ""), 5),
                                                                                      _createElementVNode("td", {
                                                                                        class: "text-right",
                                                                                        style: _normalizeStyle(
                                                                        _ctx.glGapColor(props.item.gap)
                                                                    )
                                                                                      }, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                                            props.item.glSum,
                                                                            { currency: "" },
                                                                        )), 5),
                                                                                      _createElementVNode("td", {
                                                                                        class: "text-right",
                                                                                        style: _normalizeStyle(
                                                                        _ctx.glGapColor(props.item.gap)
                                                                    )
                                                                                      }, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                                            props.item
                                                                                .alreadyImportedSum,
                                                                            { currency: "" },
                                                                        )), 5),
                                                                                      _createElementVNode("td", {
                                                                                        class: "text-right",
                                                                                        style: _normalizeStyle(
                                                                        _ctx.glGapColor(props.item.gap)
                                                                    )
                                                                                      }, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                                            props.item.importedSum,
                                                                            { currency: "" },
                                                                        )), 5),
                                                                                      _createElementVNode("td", {
                                                                                        class: "text-right",
                                                                                        style: _normalizeStyle(
                                                                        _ctx.glGapColor(props.item.gap)
                                                                    )
                                                                                      }, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                                            props.item.gap,
                                                                            { currency: "" },
                                                                        )), 5)
                                                                                    ])
                                                                                  ]),
                                                                                  "body.append": _withCtx(() => [
                                                                                    _createElementVNode("tr", _hoisted_27, [
                                                                                      _cache[107] || (_cache[107] = _createElementVNode("th", { class: "text-start" }, "Totaux", -1)),
                                                                                      _createElementVNode("th", _hoisted_28, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                                            _ctx.sumColumn(
                                                                                _ctx.gap_depreciationAccountableAccount
                                                                                    .gapData
                                                                                    .glWithoutImportResume,
                                                                                "glSum",
                                                                            ),
                                                                            { currency: "" },
                                                                        )), 1),
                                                                                      _createElementVNode("th", _hoisted_29, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                                            _ctx.sumColumn(
                                                                                _ctx.gap_depreciationAccountableAccount
                                                                                    .gapData
                                                                                    .glWithoutImportResume,
                                                                                "alreadyImportedSum",
                                                                            ),
                                                                            { currency: "" },
                                                                        )), 1),
                                                                                      _createElementVNode("th", _hoisted_30, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                                            _ctx.sumColumn(
                                                                                _ctx.gap_depreciationAccountableAccount
                                                                                    .gapData
                                                                                    .glWithoutImportResume,
                                                                                "importedSum",
                                                                            ),
                                                                            { currency: "" },
                                                                        )), 1),
                                                                                      _createElementVNode("th", _hoisted_31, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                                            _ctx.sumColumn(
                                                                                _ctx.gap_depreciationAccountableAccount
                                                                                    .gapData
                                                                                    .glWithoutImportResume,
                                                                                "gap",
                                                                            ),
                                                                            { currency: "" },
                                                                        )), 1)
                                                                                    ])
                                                                                  ]),
                                                                                  _: 1
                                                                                }, 8, ["headers", "items"])
                                                                              ]),
                                                                              _: 1
                                                                            })
                                                                          ]),
                                                                          _: 1
                                                                        }))
                                                                      : _createCommentVNode("", true),
                                                                    (_ctx.gap_depreciationAccountableAccount)
                                                                      ? (_openBlock(), _createBlock(_component_v_row, {
                                                                          key: 1,
                                                                          "no-gutters": "",
                                                                          class: "pt-4 pb-2"
                                                                        }, {
                                                                          default: _withCtx(() => [
                                                                            (
                                                        _ctx.gap_depreciationAccountableAccount.gapData &&
                                                        !_ctx.gap_depreciationAccountableAccount.gapData
                                                            .sumGap
                                                    )
                                                                              ? (_openBlock(), _createBlock(_component_v_col, { key: 0 }, {
                                                                                  default: _withCtx(() => _cache[108] || (_cache[108] = [
                                                                                    _createElementVNode("h3", null, " Détails des AMORTISSEMENTS LINEAIRES importées dont les comptes comptables ne trouvent pas de correspondance dans le grand livre : ", -1)
                                                                                  ])),
                                                                                  _: 1
                                                                                }))
                                                                              : _createCommentVNode("", true)
                                                                          ]),
                                                                          _: 1
                                                                        }))
                                                                      : _createCommentVNode("", true),
                                                                    _createVNode(_component_oss_data_table, {
                                                                      headers: _ctx.gapsImportedLinesHeaders28,
                                                                      items: 
                                                    _ctx.gap_depreciationAccountableAccount.gapData
                                                        .importLinesWithoutGl
                                                ,
                                                                      striped: true,
                                                                      "x-dense": true,
                                                                      class: "table"
                                                                    }, {
                                                                      item: _withCtx((props) => [
                                                                        _createElementVNode("tr", null, [
                                                                          _createElementVNode("td", _hoisted_32, _toDisplayString(props.item.aaNameFixedAsset || ""), 1),
                                                                          _createElementVNode("td", {
                                                                            class: "text-left",
                                                                            style: _normalizeStyle(
                                                                _ctx.gapSelectColor(
                                                                    props.item,
                                                                    'aaNameDepreciation',
                                                                )
                                                            )
                                                                          }, _toDisplayString(props.item.aaNameDepreciation || ""), 5),
                                                                          _createElementVNode("td", _hoisted_33, [
                                                                            (
                                                                    _ctx.gap_depreciationAccountableAccount &&
                                                                    _ctx.gap_depreciationAccountableAccount.gapData &&
                                                                    _ctx.gap_depreciationAccountableAccount
                                                                        .gapData
                                                                        .toProposeGlAccountableAccounts
                                                                )
                                                                              ? (_openBlock(), _createBlock(_component_v_select_filled, {
                                                                                  key: 0,
                                                                                  modelValue: 
                                                                    props.item
                                                                        .changedAccountableAccount
                                                                ,
                                                                                  "onUpdate:modelValue": [
                                                                                    ($event: any) => ((
                                                                    props.item
                                                                        .changedAccountableAccount
                                                                ) = $event),
                                                                                    _cache[22] || (_cache[22] = ($event: any) => (
                                                                    _ctx.changeNoGapFixedAssetAccountableAccounts(
                                                                        'depreciations',
                                                                    )
                                                                ))
                                                                                  ],
                                                                                  items: 
                                                                    _ctx.gap_depreciationAccountableAccount
                                                                        .gapData
                                                                        .toProposeGlAccountableAccounts
                                                                ,
                                                                                  "hide-details": true,
                                                                                  density: "compact",
                                                                                  "item-title": (item) => item.text
                                                                                }, null, 8, ["modelValue", "onUpdate:modelValue", "items", "item-title"]))
                                                                              : _createCommentVNode("", true)
                                                                          ]),
                                                                          _createElementVNode("td", _hoisted_34, _toDisplayString(props.item.date || ""), 1),
                                                                          _createElementVNode("td", _hoisted_35, _toDisplayString(props.item.wording || ""), 1),
                                                                          _createElementVNode("td", _hoisted_36, _toDisplayString(props.item.type || ""), 1),
                                                                          _createElementVNode("td", _hoisted_37, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                                    props.item.rate,
                                                                    { currency: "" },
                                                                )), 1),
                                                                          _createElementVNode("td", _hoisted_38, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                                    props.item.alNetAmountSigned,
                                                                    { currency: "" },
                                                                )), 1),
                                                                          _createElementVNode("td", _hoisted_39, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                                    props.item
                                                                        .previousDepreciationAmountSigned,
                                                                    { currency: "" },
                                                                )), 1)
                                                                        ])
                                                                      ]),
                                                                      _: 1
                                                                    }, 8, ["headers", "items"])
                                                                  ]))
                                                                : (_ctx.changeDerogationAccountableAccountGap)
                                                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                                                      _createElementVNode("div", _hoisted_40, [
                                                                        _cache[113] || (_cache[113] = _createElementVNode("h2", { class: "pb-2" }, " Aucun écart global sur les COMPTES D'AMORTISSEMENT DEROGATOIRE, il suffit de modifier les comptes comptables ", -1)),
                                                                        (_ctx.gap_derogationAccountableAccount)
                                                                          ? (_openBlock(), _createBlock(_component_v_row, {
                                                                              key: 0,
                                                                              "no-gutters": ""
                                                                            }, {
                                                                              default: _withCtx(() => [
                                                                                _createVNode(_component_v_col, {
                                                                                  cols: "4",
                                                                                  class: "d-flex align-center"
                                                                                }, {
                                                                                  default: _withCtx(() => _cache[110] || (_cache[110] = [
                                                                                    _createElementVNode("h4", null, "Ecarts sur le grand livre :", -1)
                                                                                  ])),
                                                                                  _: 1
                                                                                }),
                                                                                _createVNode(_component_v_col, { cols: "8" }, {
                                                                                  default: _withCtx(() => [
                                                                                    _createVNode(_component_oss_data_table, {
                                                                                      headers: _ctx.gapsGlHeaders,
                                                                                      items: 
                                                            _ctx.gap_derogationAccountableAccount.gapData
                                                                .glWithoutImportResume
                                                        ,
                                                                                      striped: true,
                                                                                      "x-dense": true,
                                                                                      class: "table"
                                                                                    }, {
                                                                                      item: _withCtx((props) => [
                                                                                        _createElementVNode("tr", null, [
                                                                                          _createElementVNode("td", {
                                                                                            class: "text-left",
                                                                                            style: _normalizeStyle(
                                                                        _ctx.glGapColor(props.item.gap)
                                                                    )
                                                                                          }, _toDisplayString(props.item.aaName || ""), 5),
                                                                                          _createElementVNode("td", {
                                                                                            class: "text-right",
                                                                                            style: _normalizeStyle(
                                                                        _ctx.glGapColor(props.item.gap)
                                                                    )
                                                                                          }, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                                            props.item.glSum,
                                                                            { currency: "" },
                                                                        )), 5),
                                                                                          _createElementVNode("td", {
                                                                                            class: "text-right",
                                                                                            style: _normalizeStyle(
                                                                        _ctx.glGapColor(props.item.gap)
                                                                    )
                                                                                          }, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                                            props.item
                                                                                .alreadyImportedSum,
                                                                            { currency: "" },
                                                                        )), 5),
                                                                                          _createElementVNode("td", {
                                                                                            class: "text-right",
                                                                                            style: _normalizeStyle(
                                                                        _ctx.glGapColor(props.item.gap)
                                                                    )
                                                                                          }, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                                            props.item.importedSum,
                                                                            { currency: "" },
                                                                        )), 5),
                                                                                          _createElementVNode("td", {
                                                                                            class: "text-right",
                                                                                            style: _normalizeStyle(
                                                                        _ctx.glGapColor(props.item.gap)
                                                                    )
                                                                                          }, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                                            props.item.gap,
                                                                            { currency: "" },
                                                                        )), 5)
                                                                                        ])
                                                                                      ]),
                                                                                      "body.append": _withCtx(() => [
                                                                                        _createElementVNode("tr", _hoisted_41, [
                                                                                          _cache[111] || (_cache[111] = _createElementVNode("th", { class: "text-start" }, "Totaux", -1)),
                                                                                          _createElementVNode("th", _hoisted_42, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                                            _ctx.sumColumn(
                                                                                _ctx.gap_derogationAccountableAccount
                                                                                    .gapData
                                                                                    .glWithoutImportResume,
                                                                                "glSum",
                                                                            ),
                                                                            { currency: "" },
                                                                        )), 1),
                                                                                          _createElementVNode("th", _hoisted_43, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                                            _ctx.sumColumn(
                                                                                _ctx.gap_derogationAccountableAccount
                                                                                    .gapData
                                                                                    .glWithoutImportResume,
                                                                                "alreadyImportedSum",
                                                                            ),
                                                                            { currency: "" },
                                                                        )), 1),
                                                                                          _createElementVNode("th", _hoisted_44, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                                            _ctx.sumColumn(
                                                                                _ctx.gap_fixedAssetsAccountableAccount
                                                                                    .gapData
                                                                                    .glWithoutImportResume,
                                                                                "importedSum",
                                                                            ),
                                                                            { currency: "" },
                                                                        )), 1),
                                                                                          _createElementVNode("th", _hoisted_45, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                                            _ctx.sumColumn(
                                                                                _ctx.gap_derogationAccountableAccount
                                                                                    .gapData
                                                                                    .glWithoutImportResume,
                                                                                "gap",
                                                                            ),
                                                                            { currency: "" },
                                                                        )), 1)
                                                                                        ])
                                                                                      ]),
                                                                                      _: 1
                                                                                    }, 8, ["headers", "items"])
                                                                                  ]),
                                                                                  _: 1
                                                                                })
                                                                              ]),
                                                                              _: 1
                                                                            }))
                                                                          : _createCommentVNode("", true),
                                                                        (_ctx.gap_depreciationAccountableAccount)
                                                                          ? (_openBlock(), _createBlock(_component_v_row, {
                                                                              key: 1,
                                                                              "no-gutters": "",
                                                                              class: "pt-4 pb-2"
                                                                            }, {
                                                                              default: _withCtx(() => [
                                                                                (
                                                        _ctx.gap_depreciationAccountableAccount.gapData &&
                                                        !_ctx.gap_depreciationAccountableAccount.gapData
                                                            .sumGap
                                                    )
                                                                                  ? (_openBlock(), _createBlock(_component_v_col, { key: 0 }, {
                                                                                      default: _withCtx(() => _cache[112] || (_cache[112] = [
                                                                                        _createElementVNode("h3", null, " Détails des AMORTISSEMENTS DEROGATOIRES importées dont les comptes comptables ne trouvent pas de correspondance dans le grand livre : ", -1)
                                                                                      ])),
                                                                                      _: 1
                                                                                    }))
                                                                                  : _createCommentVNode("", true)
                                                                              ]),
                                                                              _: 1
                                                                            }))
                                                                          : _createCommentVNode("", true)
                                                                      ]),
                                                                      _createVNode(_component_oss_data_table, {
                                                                        headers: _ctx.gapsImportedLinesHeaders28,
                                                                        items: 
                                                _ctx.gap_derogationAccountableAccount.gapData
                                                    .importLinesWithoutGl
                                            ,
                                                                        striped: true,
                                                                        "x-dense": true,
                                                                        class: "table"
                                                                      }, {
                                                                        item: _withCtx((props) => [
                                                                          _createElementVNode("tr", null, [
                                                                            _createElementVNode("td", _hoisted_46, _toDisplayString(props.item.aaNameFixedAsset || ""), 1),
                                                                            _createElementVNode("td", {
                                                                              class: "text-left",
                                                                              style: _normalizeStyle(
                                                            _ctx.gapSelectColor(
                                                                props.item,
                                                                'aaNameDepreciation',
                                                            )
                                                        )
                                                                            }, _toDisplayString(props.item.aaNameDepreciation || ""), 5),
                                                                            _createElementVNode("td", _hoisted_47, [
                                                                              (
                                                                _ctx.gap_derogationAccountableAccount &&
                                                                _ctx.gap_derogationAccountableAccount.gapData &&
                                                                _ctx.gap_derogationAccountableAccount
                                                                    .gapData
                                                                    .toProposeGlAccountableAccounts
                                                            )
                                                                                ? (_openBlock(), _createBlock(_component_v_select_filled, {
                                                                                    key: 0,
                                                                                    modelValue: 
                                                                props.item.changedAccountableAccount
                                                            ,
                                                                                    "onUpdate:modelValue": [
                                                                                      ($event: any) => ((
                                                                props.item.changedAccountableAccount
                                                            ) = $event),
                                                                                      _cache[23] || (_cache[23] = ($event: any) => (
                                                                _ctx.changeNoGapFixedAssetAccountableAccounts(
                                                                    'depreciations',
                                                                )
                                                            ))
                                                                                    ],
                                                                                    items: 
                                                                _ctx.gap_derogationAccountableAccount
                                                                    .gapData
                                                                    .toProposeGlAccountableAccounts
                                                            ,
                                                                                    "hide-details": true,
                                                                                    density: "compact",
                                                                                    "item-title": (item) => item.text
                                                                                  }, null, 8, ["modelValue", "onUpdate:modelValue", "items", "item-title"]))
                                                                                : _createCommentVNode("", true)
                                                                            ]),
                                                                            _createElementVNode("td", _hoisted_48, _toDisplayString(props.item.date || ""), 1),
                                                                            _createElementVNode("td", _hoisted_49, _toDisplayString(props.item.wording || ""), 1),
                                                                            _createElementVNode("td", _hoisted_50, _toDisplayString(props.item.type || ""), 1),
                                                                            _createElementVNode("td", _hoisted_51, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                                props.item.rate,
                                                                { currency: "" },
                                                            )), 1),
                                                                            _createElementVNode("td", _hoisted_52, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                                props.item.alNetAmountSigned,
                                                                { currency: "" },
                                                            )), 1),
                                                                            _createElementVNode("td", _hoisted_53, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                                props.item
                                                                    .previousDepreciationAmountSigned,
                                                                { currency: "" },
                                                            )), 1)
                                                                          ])
                                                                        ]),
                                                                        _: 1
                                                                      }, 8, ["headers", "items"])
                                                                    ], 64))
                                                                  : _createCommentVNode("", true)
                                                          ]),
                                                          _: 1
                                                        })
                                                      ]),
                                                      _: 1
                                                    }, 8, ["modelValue"])
                                                  ]),
                                                  _: 1
                                                }, 8, ["modelValue", "validDisabled"]))
                                              : _createCommentVNode("", true),
                                            (!_ctx.someDecliningDepreciationError && _ctx.fullGapsDialog)
                                              ? (_openBlock(), _createBlock(_component_oss_dialog, {
                                                  key: 1,
                                                  modelValue: _ctx.fullGapsDialog,
                                                  "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.fullGapsDialog) = $event)),
                                                  withoutHeader: "true",
                                                  actions: _ctx.actions,
                                                  onClose: _cache[33] || (_cache[33] = ($event: any) => (_ctx.closeDialog())),
                                                  "min-width": "80vw"
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_window, {
                                                      modelValue: _ctx.incompleteFECStep,
                                                      "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.incompleteFECStep) = $event))
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_v_window_item, { value: 'alert' }, {
                                                          default: _withCtx(() => [
                                                            _createVNode(_component_v_alert, {
                                                              border: "start",
                                                              "border-color": "red",
                                                              elevation: "0",
                                                              class: "py-4 mb-0"
                                                            }, {
                                                              default: _withCtx(() => [
                                                                _cache[116] || (_cache[116] = _createElementVNode("h3", null, "ATTENTION ECARTS !", -1)),
                                                                _cache[117] || (_cache[117] = _createElementVNode("h3", null, " Les totaux du fichier importé sont différents des totaux des reprises des à nouveaux ", -1)),
                                                                _cache[118] || (_cache[118] = _createElementVNode("h4", null, " Vérifier, avant de continuer : l'import concerne bien la dernière période clôturée ? ", -1)),
                                                                _createVNode(_component_v_row, {
                                                                  "no-gutters": "",
                                                                  class: "d-flex pl-4 py-0"
                                                                }, {
                                                                  default: _withCtx(() => [
                                                                    _createVNode(_component_v_spacer),
                                                                    _createVNode(_component_v_col, {
                                                                      cols: "auto",
                                                                      class: "px-4"
                                                                    }, {
                                                                      default: _withCtx(() => [
                                                                        _createVNode(_component_v_btn, {
                                                                          dense: "",
                                                                          rounded: "",
                                                                          elevation: "0",
                                                                          onClick: _cache[28] || (_cache[28] = ($event: any) => {
                                                        _ctx.fullGapsDialog = false;
                                                        _ctx.accountableAccountLinesSelected = [];
                                                        _ctx.importFunction();
                                                    })
                                                                        }, {
                                                                          default: _withCtx(() => _cache[114] || (_cache[114] = [
                                                                            _createTextVNode(" Non : ré-importer le bon fichier ")
                                                                          ])),
                                                                          _: 1
                                                                        })
                                                                      ]),
                                                                      _: 1
                                                                    }),
                                                                    _createVNode(_component_v_col, { cols: "1" }, {
                                                                      default: _withCtx(() => [
                                                                        _createVNode(_component_v_btn, {
                                                                          dense: "",
                                                                          rounded: "",
                                                                          elevation: "0",
                                                                          onClick: _cache[29] || (_cache[29] = ($event: any) => (
                                                        _ctx.incompleteFECStep = _ctx.getIncompleteFECStep
                                                    ))
                                                                        }, {
                                                                          default: _withCtx(() => _cache[115] || (_cache[115] = [
                                                                            _createTextVNode(" Oui ")
                                                                          ])),
                                                                          _: 1
                                                                        })
                                                                      ]),
                                                                      _: 1
                                                                    })
                                                                  ]),
                                                                  _: 1
                                                                })
                                                              ]),
                                                              _: 1
                                                            })
                                                          ]),
                                                          _: 1
                                                        }),
                                                        _createVNode(_component_v_window_item, { value: 'accountableAccountsList' }, {
                                                          default: _withCtx(() => [
                                                            _cache[119] || (_cache[119] = _createElementVNode("h1", { class: "d-flex px-4 py-0 justify-center text-primary" }, " Ces comptes du grand livre ont un solde inférieur à l'import ", -1)),
                                                            (_ctx.gapToAffect)
                                                              ? (_openBlock(), _createElementBlock("h2", _hoisted_54, " S'il est impossible d'identifier les lignes à intégrer, il sera indispensable de corriger le fichier d'immobilisations/amortissements N-1 et de le réimporter. "))
                                                              : _createCommentVNode("", true),
                                                            _cache[120] || (_cache[120] = _createElementVNode("h2", { class: "d-flex px-4 pb-0 justify-center text-primary" }, " Soyez vigilants ! Il peut s'agir d'immobilisations déjà sorties. ", -1)),
                                                            _cache[121] || (_cache[121] = _createElementVNode("h2", { class: "d-flex px-4 pb-2 justify-center text-primary" }, " Dans ce cas, nous vous conseillons de les effacer du tableau d'immobilisations/amortissements N-1 et de procéder à un nouvel import. ", -1)),
                                                            _cache[122] || (_cache[122] = _createElementVNode("h3", { class: "d-flex px-4 pb-2 justify-center" }, " Cette fonction sert à intégrer des immobilisations ou un amortissements présents dans le logiciel d'immobilisation, mais pas comptabilisés. ", -1)),
                                                            _cache[123] || (_cache[123] = _createElementVNode("h3", { class: "d-flex px-4 pb-2 justify-center" }, " Elle va générer, au premier jour de l'exercice en cours, des écritures de type \"2 à 404\" ou \"68 à 28\". ", -1)),
                                                            _cache[124] || (_cache[124] = _createElementVNode("h3", { class: "d-flex px-4 py-2 justify-center" }, " Les lignes que vous allez sélectionner doivent, cumulées, obtenir le même montant que l'écart. ", -1)),
                                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.gaps, (group, key) => {
                                                              return (_openBlock(), _createElementBlock("div", { key: key }, [
                                                                (_openBlock(), _createBlock(_component_v_list_item, {
                                                                  key: key,
                                                                  class: "oss-list-item ma-0",
                                                                  ripple: ""
                                                                }, {
                                                                  default: _withCtx(() => [
                                                                    _createVNode(_component_v_list_item_title, { class: "pb-2" }, {
                                                                      default: _withCtx(() => [
                                                                        _createVNode(_component_v_row, {
                                                                          "no-gutter": "",
                                                                          class: _normalizeClass('pt-2 ' + _ctx.glGapColor(_ctx.gapToAffect))
                                                                        }, {
                                                                          default: _withCtx(() => [
                                                                            _createVNode(_component_v_col, null, {
                                                                              default: _withCtx(() => [
                                                                                _createElementVNode("h3", null, "Ecarts sur la racine " + _toDisplayString(key), 1)
                                                                              ]),
                                                                              _: 2
                                                                            }, 1024),
                                                                            _createVNode(_component_v_spacer),
                                                                            _createVNode(_component_v_col, null, {
                                                                              default: _withCtx(() => [
                                                                                _createElementVNode("h4", null, " A identifier : " + _toDisplayString(_ctx.newCommonFormatCurrency(
                                                                    group.sumGap,
                                                                    undefined,
                                                                )), 1)
                                                                              ]),
                                                                              _: 2
                                                                            }, 1024),
                                                                            _createVNode(_component_v_spacer),
                                                                            _createVNode(_component_v_col, null, {
                                                                              default: _withCtx(() => [
                                                                                _createElementVNode("h4", null, " Total lignes séléctionnées : " + _toDisplayString(_ctx.newCommonFormatCurrency(
                                                                    _ctx.sumSelectedGaps,
                                                                    undefined,
                                                                )), 1)
                                                                              ]),
                                                                              _: 1
                                                                            }),
                                                                            _createVNode(_component_v_spacer),
                                                                            _createVNode(_component_v_col, null, {
                                                                              default: _withCtx(() => [
                                                                                _createElementVNode("h4", null, " Ecart restant : " + _toDisplayString(_ctx.newCommonFormatCurrency(
                                                                    _ctx.gapToAffect,
                                                                    undefined,
                                                                )), 1)
                                                                              ]),
                                                                              _: 1
                                                                            })
                                                                          ]),
                                                                          _: 2
                                                                        }, 1032, ["class"])
                                                                      ]),
                                                                      _: 2
                                                                    }, 1024),
                                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.gaps[key]
                                                    .importWithoutGlResume, (accAccount, index) => {
                                                                      return (_openBlock(), _createElementBlock("div", { key: index }, [
                                                                        (_openBlock(), _createBlock(_component_v_list_item, {
                                                                          class: "oss-list-item",
                                                                          key: index
                                                                        }, {
                                                                          default: _withCtx(() => [
                                                                            _createVNode(_component_v_list_item_subtitle, null, {
                                                                              default: _withCtx(() => [
                                                                                _createVNode(_component_v_row, {
                                                                                  "no-gutters": "",
                                                                                  class: "d-flex align-center"
                                                                                }, {
                                                                                  default: _withCtx(() => [
                                                                                    _createVNode(_component_v_col, null, {
                                                                                      default: _withCtx(() => [
                                                                                        _createTextVNode("• c/" + _toDisplayString(accAccount.aaName) + " - Total importé : " + _toDisplayString(_ctx.newCommonFormatCurrency(
                                                                        accAccount.importedSum,
                                                                        undefined,
                                                                    )) + " - Total à nouveaux : " + _toDisplayString(_ctx.newCommonFormatCurrency(
                                                                        accAccount.glSum,
                                                                        undefined,
                                                                    )) + " - Ecart : " + _toDisplayString(_ctx.newCommonFormatCurrency(
                                                                        accAccount.gap,
                                                                        undefined,
                                                                    )), 1)
                                                                                      ]),
                                                                                      _: 2
                                                                                    }, 1024),
                                                                                    _createVNode(_component_v_spacer),
                                                                                    _createVNode(_component_v_col, {
                                                                                      cols: "1",
                                                                                      class: "d-flex align-center justify-center"
                                                                                    }, {
                                                                                      default: _withCtx(() => [
                                                                                        _createVNode(_component_v_row, { "no-gutters": "" }, {
                                                                                          default: _withCtx(() => [
                                                                                            _createVNode(_component_v_col, {
                                                                                              cols: "6",
                                                                                              class: "align-center"
                                                                                            }),
                                                                                            _createVNode(_component_v_col, {
                                                                                              cols: "6",
                                                                                              class: "align-center"
                                                                                            }, {
                                                                                              default: _withCtx(() => [
                                                                                                _createVNode(_component_v_btn_icon, {
                                                                                                  icon: 
                                                                                _ctx.isAccAccountExpanded(
                                                                                    accAccount.aaName,
                                                                                )
                                                                                    ? '$fa-chevron-up'
                                                                                    : '$fa-chevron-down'
                                                                            ,
                                                                                                  "data-cy": "CheckFixedAssetsCutPrevious-immobilisations",
                                                                                                  onClick: ($event: any) => (
                                                                                _ctx.addRemoveAccAccountExpanded(
                                                                                    accAccount.aaName,
                                                                                    key,
                                                                                )
                                                                            )
                                                                                                }, null, 8, ["icon", "onClick"])
                                                                                              ]),
                                                                                              _: 2
                                                                                            }, 1024)
                                                                                          ]),
                                                                                          _: 2
                                                                                        }, 1024)
                                                                                      ]),
                                                                                      _: 2
                                                                                    }, 1024)
                                                                                  ]),
                                                                                  _: 2
                                                                                }, 1024)
                                                                              ]),
                                                                              _: 2
                                                                            }, 1024),
                                                                            (
                                                            _ctx.isAccAccountExpanded(accAccount.aaName)
                                                        )
                                                                              ? (_openBlock(), _createBlock(_component_v_card, { key: 0 }, {
                                                                                  default: _withCtx(() => [
                                                                                    _createVNode(_component_v_card_text, null, {
                                                                                      default: _withCtx(() => [
                                                                                        _createVNode(_component_v_data_table, {
                                                                                          headers: 
                                                                        _ctx.selectedGapAccAccountImportedLinesHea
                                                                    ,
                                                                                          items: 
                                                                        _ctx.expandedAccAccountImportedLinesWithoutGl(
                                                                            accAccount.aaName,
                                                                        )
                                                                    ,
                                                                                          "fixed-header": "",
                                                                                          modelValue: _ctx.selectedFullGapsLines,
                                                                                          "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.selectedFullGapsLines) = $event)),
                                                                                          "items-per-page": -1,
                                                                                          "hide-default-footer": "",
                                                                                          "disable-pagination": "",
                                                                                          class: "table",
                                                                                          "show-select": "",
                                                                                          "single-select": _ctx.singleSelect,
                                                                                          "item-value": 
                                                                        (item) => item.index
                                                                    ,
                                                                                          density: "compact"
                                                                                        }, {
                                                                                          "item.alNetAmountSigned": _withCtx(({
                                                                            item,
                                                                        }) => [
                                                                                            _createTextVNode(_toDisplayString(_ctx.newCommonFormatCurrency(
                                                                                item.alNetAmountSigned,
                                                                                undefined,
                                                                            )), 1)
                                                                                          ]),
                                                                                          "item.previousDepreciationAmountSigned": _withCtx(({
                                                                            item,
                                                                        }) => [
                                                                                            _createTextVNode(_toDisplayString(_ctx.newCommonFormatCurrency(
                                                                                item.previousDepreciationAmountSigned,
                                                                                undefined,
                                                                            )), 1)
                                                                                          ]),
                                                                                          _: 2
                                                                                        }, 1032, ["headers", "items", "modelValue", "single-select", "item-value"])
                                                                                      ]),
                                                                                      _: 2
                                                                                    }, 1024)
                                                                                  ]),
                                                                                  _: 2
                                                                                }, 1024))
                                                                              : _createCommentVNode("", true)
                                                                          ]),
                                                                          _: 2
                                                                        }, 1024))
                                                                      ]))
                                                                    }), 128))
                                                                  ]),
                                                                  _: 2
                                                                }, 1024))
                                                              ]))
                                                            }), 128))
                                                          ]),
                                                          _: 1
                                                        }),
                                                        _createVNode(_component_v_window_item, { value: 'glWithoutImportResume' }, {
                                                          default: _withCtx(() => [
                                                            _cache[128] || (_cache[128] = _createElementVNode("h2", { class: "d-flex px-4 py-0" }, " Le solde du grand livre est supérieur au solde de l'import : ", -1)),
                                                            (_ctx.gap_fixedAssetsAccountableAccount)
                                                              ? (_openBlock(), _createBlock(_component_v_row, {
                                                                  key: 0,
                                                                  "no-gutters": "",
                                                                  class: "d-flex px-4 py-0"
                                                                }, {
                                                                  default: _withCtx(() => [
                                                                    _createVNode(_component_v_col, {
                                                                      cols: "8",
                                                                      class: "d-flex align-center"
                                                                    }, {
                                                                      default: _withCtx(() => _cache[125] || (_cache[125] = [
                                                                        _createElementVNode("h4", null, " Merci d'intégrer les comptes / montants suivants dans le fichier et de renouveler l'import : ", -1)
                                                                      ])),
                                                                      _: 1
                                                                    }),
                                                                    _createVNode(_component_v_col, { cols: "4" }, {
                                                                      default: _withCtx(() => [
                                                                        _createVNode(_component_oss_data_table, {
                                                                          headers: _ctx.gapsGlWithoutImportsHeaders,
                                                                          items: 
                                                    _ctx.gap_fixedAssetsAccountableAccount.gapData
                                                        .glWithoutImportResume
                                                ,
                                                                          striped: true,
                                                                          "x-dense": true,
                                                                          class: "table"
                                                                        }, {
                                                                          item: _withCtx((props) => [
                                                                            _createElementVNode("tr", null, [
                                                                              _createElementVNode("td", {
                                                                                class: "text-left",
                                                                                style: _normalizeStyle(_ctx.glGapColor(props.item.gap))
                                                                              }, _toDisplayString(props.item.aaName || ""), 5),
                                                                              _createElementVNode("td", {
                                                                                class: "text-right",
                                                                                style: _normalizeStyle(_ctx.glGapColor(props.item.gap))
                                                                              }, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                                    props.item.gap,
                                                                    { currency: "" },
                                                                )), 5)
                                                                            ])
                                                                          ]),
                                                                          "body.append": _withCtx(() => [
                                                                            _createElementVNode("tr", _hoisted_55, [
                                                                              _cache[126] || (_cache[126] = _createElementVNode("th", { class: "text-start" }, "Totaux", -1)),
                                                                              _createElementVNode("th", _hoisted_56, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                                    _ctx.sumColumn(
                                                                        _ctx.gap_fixedAssetsAccountableAccount
                                                                            .gapData
                                                                            .glWithoutImportResume,
                                                                        "gap",
                                                                    ),
                                                                    { currency: "" },
                                                                )), 1)
                                                                            ])
                                                                          ]),
                                                                          _: 1
                                                                        }, 8, ["headers", "items"])
                                                                      ]),
                                                                      _: 1
                                                                    })
                                                                  ]),
                                                                  _: 1
                                                                }))
                                                              : _createCommentVNode("", true),
                                                            (_ctx.gap_fixedAssetsAccountableAccount)
                                                              ? (_openBlock(), _createBlock(_component_v_row, {
                                                                  key: 1,
                                                                  "no-gutters": "",
                                                                  class: "pt-4 pb-2"
                                                                }, {
                                                                  default: _withCtx(() => [
                                                                    (
                                                _ctx.gap_fixedAssetsAccountableAccount.gapData &&
                                                !_ctx.gap_fixedAssetsAccountableAccount.gapData.sumGap
                                            )
                                                                      ? (_openBlock(), _createBlock(_component_v_col, { key: 0 }, {
                                                                          default: _withCtx(() => _cache[127] || (_cache[127] = [
                                                                            _createElementVNode("h3", { class: "py-2" }, " Détails des immobilisations importées dont les comptes comptables ne trouvent pas de correspondance dans le grand livre : ", -1)
                                                                          ])),
                                                                          _: 1
                                                                        }))
                                                                      : _createCommentVNode("", true)
                                                                  ]),
                                                                  _: 1
                                                                }))
                                                              : _createCommentVNode("", true)
                                                          ]),
                                                          _: 1
                                                        })
                                                      ]),
                                                      _: 1
                                                    }, 8, ["modelValue"])
                                                  ]),
                                                  _: 1
                                                }, 8, ["modelValue", "actions"]))
                                              : _createCommentVNode("", true),
                                            (
                                !_ctx.someDecliningDepreciationError &&
                                _ctx.gap68LOnRegulN_1Errors &&
                                _ctx.gap68LOnRegulN_1Errors.length
                            )
                                              ? (_openBlock(), _createBlock(_component_oss_dialog, {
                                                  key: 2,
                                                  modelValue: _ctx.gap68LOnRegulN_1ErrorsDialog,
                                                  "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.gap68LOnRegulN_1ErrorsDialog) = $event)),
                                                  withoutHeader: "true",
                                                  onClose: _cache[35] || (_cache[35] = ($event: any) => (_ctx.closeDialog())),
                                                  onValid: _cache[36] || (_cache[36] = ($event: any) => (_ctx.updateLinearSpreadStartDate())),
                                                  validTitle: "Enregistrer",
                                                  "valid-disabled": !_ctx.showUpdatedLinearSpreadStartDateBtn,
                                                  "min-width": "90vw"
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_alert, {
                                                      border: "start",
                                                      "border-color": "red",
                                                      elevation: "0",
                                                      class: "py-4 mb-0"
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _cache[130] || (_cache[130] = _createElementVNode("h3", null, "ATTENTION ECARTS !", -1)),
                                                        _cache[131] || (_cache[131] = _createElementVNode("h3", null, " Les immobilisations suivantes présentent un écart lors de la génération de la reprise. ", -1)),
                                                        _cache[132] || (_cache[132] = _createElementVNode("h4", { class: "pb-4" }, " Avant de continuer : corriger la date de mise en service. ", -1)),
                                                        _createVNode(_component_v_data_table, {
                                                          items: _ctx.gap68LOnRegulN_1Errors,
                                                          headers: _ctx.gap68OnRegulN_1ErrorsHeaders,
                                                          "fixed-header": "",
                                                          "max-height": "56vh",
                                                          "items-per-page": -1,
                                                          "hide-default-footer": "",
                                                          "disable-pagination": "",
                                                          class: "table",
                                                          density: "compact"
                                                        }, {
                                                          "no-data": _withCtx(() => _cache[129] || (_cache[129] = [
                                                            _createTextVNode("Aucune charge à réintégrer")
                                                          ])),
                                                          item: _withCtx((props) => [
                                                            _createElementVNode("tr", null, [
                                                              (
                                                    props.item.currentAlAcrData.accountableAccount
                                                        .name
                                                )
                                                                ? (_openBlock(), _createElementBlock("td", _hoisted_57, _toDisplayString(props.item.currentAlAcrData.accountableAccount
                                                        .name), 1))
                                                                : _createCommentVNode("", true),
                                                              (props.item.currentAlAcrData.fixedAssetWording)
                                                                ? (_openBlock(), _createElementBlock("td", _hoisted_58, _toDisplayString(props.item.currentAlAcrData.fixedAssetWording), 1))
                                                                : _createCommentVNode("", true),
                                                              (props.item.currentAlAcrData.date)
                                                                ? (_openBlock(), _createElementBlock("td", _hoisted_59, _toDisplayString(_ctx.formatDate(props.item.currentAlAcrData.date)), 1))
                                                                : _createCommentVNode("", true),
                                                              (
                                                    props.item.currentAlAcrData.selectedYearDuration
                                                )
                                                                ? (_openBlock(), _createElementBlock("td", _hoisted_60, _toDisplayString(props.item.currentAlAcrData.selectedYearDuration), 1))
                                                                : _createCommentVNode("", true),
                                                              (props.item.currentAlAcrData.alNetAmountSigned)
                                                                ? (_openBlock(), _createElementBlock("td", _hoisted_61, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                        props.item.currentAlAcrData
                                                            .alNetAmountSigned,
                                                        undefined,
                                                    )), 1))
                                                                : _createCommentVNode("", true),
                                                              (
                                                    props.item.currentAlAcrData
                                                        .previousDepreciationAmountSigned
                                                )
                                                                ? (_openBlock(), _createElementBlock("td", _hoisted_62, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                        props.item.currentAlAcrData
                                                            .previousDepreciationAmountSigned,
                                                        undefined,
                                                    )), 1))
                                                                : _createCommentVNode("", true),
                                                              (props.item.calculatedSumAmount)
                                                                ? (_openBlock(), _createElementBlock("td", _hoisted_63, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                        props.item.calculatedSumAmount,
                                                        undefined,
                                                    )), 1))
                                                                : _createCommentVNode("", true),
                                                              (props.item.regul68Gap)
                                                                ? (_openBlock(), _createElementBlock("td", _hoisted_64, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                        props.item.regul68Gap,
                                                        undefined,
                                                    )), 1))
                                                                : _createCommentVNode("", true),
                                                              (props.item.suggestedDate)
                                                                ? (_openBlock(), _createElementBlock("td", _hoisted_65, [
                                                                    _createElementVNode("b", null, _toDisplayString(_ctx.formatDate(props.item.suggestedDate)), 1)
                                                                  ]))
                                                                : _createCommentVNode("", true),
                                                              _createElementVNode("td", null, [
                                                                _createVNode(_component_oss_date_picker_filled, {
                                                                  modelValue: 
                                                        props.item.currentAlAcrData
                                                            .linearSpreadStartDate
                                                    ,
                                                                  "onUpdate:modelValue": ($event: any) => ((
                                                        props.item.currentAlAcrData
                                                            .linearSpreadStartDate
                                                    ) = $event),
                                                                  style: {"flex":"1"},
                                                                  textFieldReadOnly: false,
                                                                  "hide-details": ""
                                                                }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                                              ])
                                                            ])
                                                          ]),
                                                          _: 1
                                                        }, 8, ["items", "headers"])
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 1
                                                }, 8, ["modelValue", "valid-disabled"]))
                                              : _createCommentVNode("", true)
                                          ], 64))
                                        : (
                            _ctx.errorsOnFullDepreciatedFixedAssets &&
                            _ctx.errorsOnFullDepreciatedFixedAssets.length
                        )
                                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                              (_ctx.fullDepreciatedFixedAssetsDialog)
                                                ? (_openBlock(), _createBlock(_component_oss_dialog, {
                                                    key: 0,
                                                    modelValue: _ctx.fullDepreciatedFixedAssetsDialog,
                                                    "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.fullDepreciatedFixedAssetsDialog) = $event)),
                                                    withoutHeader: "true",
                                                    actions: _ctx.actions,
                                                    onClose: _cache[39] || (_cache[39] = ($event: any) => (_ctx.closeDialog())),
                                                    "min-width": "80vw"
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_v_window, {
                                                        modelValue: _ctx.incompleteFECStep,
                                                        "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.incompleteFECStep) = $event))
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createVNode(_component_v_window_item, { value: 'fullDepreciatedFixedAssets' }, {
                                                            default: _withCtx(() => [
                                                              _cache[133] || (_cache[133] = _createElementVNode("h2", { class: "d-flex px-4 py-0" }, " Des immobilisations complétement amorties ont un écart entre le cumul d'amortissements importé et le prix d'achat ", -1)),
                                                              _cache[134] || (_cache[134] = _createElementVNode("h3", { class: "d-flex px-4 pt-4" }, " bobbee va générer une écriture (68 à 28) de régularisation en N, par immobilisation concernée ", -1)),
                                                              _createVNode(_component_v_data_table, {
                                                                headers: _ctx.fullDepreciatedFixedAssetsHeaders,
                                                                items: _ctx.errorsOnFullDepreciatedFixedAssets,
                                                                "fixed-header": "",
                                                                "items-per-page": -1,
                                                                "hide-default-footer": "",
                                                                "disable-pagination": "",
                                                                class: "table",
                                                                "item-key": "index",
                                                                density: "compact"
                                                              }, {
                                                                "item.date": _withCtx(({ item }) => [
                                                                  _createTextVNode(_toDisplayString(_ctx.formatDate(item.date)), 1)
                                                                ]),
                                                                "item.linearSpreadEndDate": _withCtx(({ item }) => [
                                                                  _createTextVNode(_toDisplayString(_ctx.formatDate(item.linearSpreadEndDate)), 1)
                                                                ]),
                                                                "item.alNetAmountSigned": _withCtx(({ item }) => [
                                                                  _createTextVNode(_toDisplayString(_ctx.newCommonFormatCurrency(
                                                    item.alNetAmountSigned,
                                                    undefined,
                                                )), 1)
                                                                ]),
                                                                "item.previousDepreciationAmountSigned": _withCtx(({ item }) => [
                                                                  _createTextVNode(_toDisplayString(_ctx.newCommonFormatCurrency(
                                                    item.previousDepreciationAmountSigned,
                                                    undefined,
                                                )), 1)
                                                                ]),
                                                                "item.gap": _withCtx(({ item }) => [
                                                                  _createTextVNode(_toDisplayString(_ctx.newCommonFormatCurrency(item.gap, undefined)), 1)
                                                                ]),
                                                                _: 1
                                                              }, 8, ["headers", "items"])
                                                            ]),
                                                            _: 1
                                                          })
                                                        ]),
                                                        _: 1
                                                      }, 8, ["modelValue"])
                                                    ]),
                                                    _: 1
                                                  }, 8, ["modelValue", "actions"]))
                                                : _createCommentVNode("", true)
                                            ], 64))
                                          : _createCommentVNode("", true)
                                    ], 64))
                                  : _createCommentVNode("", true),
                              (_ctx.gl2_total || _ctx.gl2_total_filtered)
                                ? (_openBlock(), _createBlock(_component_v_card, {
                                    key: 2,
                                    elevation: "0",
                                    style: {"background-color":"white","border-radius":"25px"},
                                    class: "pa-6 mt-4"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_row, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_col, {
                                            cols: "11",
                                            class: "ma-auto"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_card_title, { class: "ma-0 pa-0" }, {
                                                default: _withCtx(() => [
                                                  _createElementVNode("h5", _hoisted_66, " Immobilisations - c/20 21 22 23 24 - Solde fin d'exercice " + _toDisplayString(_ctx.newCommonFormatCurrency(_ctx.gl2_total)) + " (dont solde début d'exercice " + _toDisplayString(_ctx.newCommonFormatCurrency(_ctx.gl2_total_filtered)) + " à reprendre) ", 1)
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_v_spacer),
                                          _createVNode(_component_v_col, {
                                            cols: "1",
                                            class: "d-flex align-center px-0 justify-center"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_row, null, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_col, { cols: "6" }),
                                                  _createVNode(_component_v_col, {
                                                    cols: "6",
                                                    class: "align-center pa-0"
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_v_btn_icon, {
                                                        icon: _ctx.showGL2 ? '$fa-chevron-up' : '$fa-chevron-down',
                                                        "data-cy": "CheckFixedAssetsCutPrevious-immobilisations",
                                                        onClick: _cache[40] || (_cache[40] = ($event: any) => (_ctx.showGL2 = !_ctx.showGL2))
                                                      }, null, 8, ["icon"])
                                                    ]),
                                                    _: 1
                                                  })
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_expand_transition, null, {
                                        default: _withCtx(() => [
                                          _withDirectives(_createElementVNode("div", null, [
                                            _createVNode(_component_v_row, null, {
                                              default: _withCtx(() => [
                                                (_openBlock(), _createBlock(_component_v_col, { key: _ctx.refreshGeneralLedger2 }, {
                                                  default: _withCtx(() => [
                                                    (_ctx.accountingPeriod)
                                                      ? (_openBlock(), _createBlock(_component_GeneralLedger, {
                                                          key: 0,
                                                          companyId: _ctx.companyId,
                                                          accountingPeriodId: _ctx.accountingPeriod.id,
                                                          accountableAccountFilter: ['20', '21', '22', '23', '24'],
                                                          inNm1: _ctx.showNm1_2,
                                                          onNm1Changed: _cache[41] || (_cache[41] = ($event: any) => (_ctx.showNm1_2 = !_ctx.showNm1_2)),
                                                          onQueryDone: _ctx.onQueryDone2
                                                        }, null, 8, ["companyId", "accountingPeriodId", "inNm1", "onQueryDone"]))
                                                      : _createCommentVNode("", true)
                                                  ]),
                                                  _: 1
                                                }))
                                              ]),
                                              _: 1
                                            })
                                          ], 512), [
                                            [_vShow, _ctx.showGL2]
                                          ])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true),
                              (_ctx.gl28_total || _ctx.gl28_total_filtered)
                                ? (_openBlock(), _createBlock(_component_v_card, {
                                    key: 3,
                                    elevation: "0",
                                    style: {"background-color":"white","border-radius":"25px"},
                                    class: "pa-6 mt-4"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_row, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_col, {
                                            cols: "11",
                                            class: "ma-auto"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_card_title, { class: "ma-0 pa-0" }, {
                                                default: _withCtx(() => [
                                                  _createElementVNode("h5", _hoisted_67, " Amortissements - c/28 - Solde fin d'exercice " + _toDisplayString(_ctx.newCommonFormatCurrency(_ctx.gl28_total)) + " (dont solde début d'exercice " + _toDisplayString(_ctx.newCommonFormatCurrency(_ctx.gl28_total_filtered)) + " à reprendre) ", 1)
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_v_spacer),
                                          _createVNode(_component_v_col, {
                                            cols: "1",
                                            class: "d-flex align-center justify-center"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_row, null, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_col, { cols: "6" }),
                                                  _createVNode(_component_v_col, {
                                                    cols: "6",
                                                    class: "align-center pa-0"
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_v_btn_icon, {
                                                        icon: _ctx.showGL28 ? '$fa-chevron-up' : '$fa-chevron-down',
                                                        onClick: _cache[42] || (_cache[42] = ($event: any) => (_ctx.showGL28 = !_ctx.showGL28))
                                                      }, null, 8, ["icon"])
                                                    ]),
                                                    _: 1
                                                  })
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_expand_transition, null, {
                                        default: _withCtx(() => [
                                          _withDirectives(_createElementVNode("div", null, [
                                            _createVNode(_component_v_row, null, {
                                              default: _withCtx(() => [
                                                (_openBlock(), _createBlock(_component_v_col, { key: _ctx.refreshGeneralLedger28 }, {
                                                  default: _withCtx(() => [
                                                    (_ctx.accountingPeriod)
                                                      ? (_openBlock(), _createBlock(_component_GeneralLedger, {
                                                          key: 0,
                                                          companyId: _ctx.companyId,
                                                          accountingPeriodId: _ctx.accountingPeriod.id,
                                                          accountableAccountFilter: ['28'],
                                                          inNm1: _ctx.showNm1_145,
                                                          onNm1Changed: _cache[43] || (_cache[43] = ($event: any) => (_ctx.showNm1_145 = !_ctx.showNm1_145)),
                                                          onQueryDone: _ctx.onQueryDone28
                                                        }, null, 8, ["companyId", "accountingPeriodId", "inNm1", "onQueryDone"]))
                                                      : _createCommentVNode("", true)
                                                  ]),
                                                  _: 1
                                                }))
                                              ]),
                                              _: 1
                                            })
                                          ], 512), [
                                            [_vShow, _ctx.showGL28]
                                          ])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true),
                              (_ctx.gl145_total || _ctx.gl145_total_filtered)
                                ? (_openBlock(), _createBlock(_component_v_card, {
                                    key: 4,
                                    elevation: "0",
                                    style: {"background-color":"white","border-radius":"25px"},
                                    class: "pa-6 mt-4"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_row, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_col, {
                                            cols: "11",
                                            class: "ma-auto"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_card_title, { class: "ma-0 pa-0" }, {
                                                default: _withCtx(() => [
                                                  _createElementVNode("h5", _hoisted_68, " Amortissements dérogatoires - c/145 - Solde fin d'exercice " + _toDisplayString(_ctx.newCommonFormatCurrency(_ctx.gl145_total)) + " (dont solde début d'exercice " + _toDisplayString(_ctx.newCommonFormatCurrency(_ctx.gl145_total_filtered)) + " à reprendre) ", 1)
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_v_spacer),
                                          _createVNode(_component_v_col, {
                                            cols: "1",
                                            class: "d-flex align-center justify-center"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_row, null, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_col, { cols: "6" }),
                                                  _createVNode(_component_v_col, {
                                                    cols: "6",
                                                    class: "align-center pa-0"
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_v_btn_icon, {
                                                        icon: _ctx.showGL145 ? '$fa-chevron-up' : '$fa-chevron-down',
                                                        onClick: _cache[44] || (_cache[44] = ($event: any) => (_ctx.showGL145 = !_ctx.showGL145))
                                                      }, null, 8, ["icon"])
                                                    ]),
                                                    _: 1
                                                  })
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_expand_transition, null, {
                                        default: _withCtx(() => [
                                          _withDirectives(_createElementVNode("div", null, [
                                            _createVNode(_component_v_row, null, {
                                              default: _withCtx(() => [
                                                (_openBlock(), _createBlock(_component_v_col, { key: _ctx.refreshGeneralLedger145 }, {
                                                  default: _withCtx(() => [
                                                    (_ctx.accountingPeriod)
                                                      ? (_openBlock(), _createBlock(_component_GeneralLedger, {
                                                          key: 0,
                                                          companyId: _ctx.companyId,
                                                          accountingPeriodId: _ctx.accountingPeriod.id,
                                                          accountableAccountFilter: ['145'],
                                                          inNm1: _ctx.showNm1_145,
                                                          onNm1Changed: _cache[45] || (_cache[45] = ($event: any) => (_ctx.showNm1_145 = !_ctx.showNm1_145)),
                                                          onQueryDone: _ctx.onQueryDone145
                                                        }, null, 8, ["companyId", "accountingPeriodId", "inNm1", "onQueryDone"]))
                                                      : _createCommentVNode("", true)
                                                  ]),
                                                  _: 1
                                                }))
                                              ]),
                                              _: 1
                                            })
                                          ], 512), [
                                            [_vShow, _ctx.showGL145]
                                          ])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true),
                              (_ctx.gl25_total || _ctx.gl25_total_filtered)
                                ? (_openBlock(), _createBlock(_component_v_card, {
                                    key: 5,
                                    elevation: "0",
                                    style: {"background-color":"white","border-radius":"25px"},
                                    class: "pa-6 mt-4"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_row, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_col, {
                                            cols: "11",
                                            class: "ma-auto"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_card_title, { class: "ma-0 pa-0" }, {
                                                default: _withCtx(() => [
                                                  _createElementVNode("h5", _hoisted_69, " Participations ou créances rattachées à des participations - c/25 - Solde fin d'exercice " + _toDisplayString(_ctx.newCommonFormatCurrency(_ctx.gl25_total)) + " (dont solde début d'exercice " + _toDisplayString(_ctx.newCommonFormatCurrency(_ctx.gl25_total_filtered)) + " à reprendre) ", 1)
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_v_spacer),
                                          _createVNode(_component_v_col, {
                                            cols: "1",
                                            class: "d-flex align-center justify-center"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_row, null, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_col, { cols: "6" }),
                                                  _createVNode(_component_v_col, {
                                                    cols: "6",
                                                    class: "align-center pa-0"
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_v_btn, {
                                                        icon: "",
                                                        onClick: _cache[46] || (_cache[46] = ($event: any) => (_ctx.showGL25 = !_ctx.showGL25))
                                                      }, {
                                                        default: _withCtx(() => [
                                                          (_ctx.showGL25 === false)
                                                            ? (_openBlock(), _createBlock(_component_v_icon, { key: 0 }, {
                                                                default: _withCtx(() => _cache[135] || (_cache[135] = [
                                                                  _createTextVNode(" $keyboard_arrow_down ")
                                                                ])),
                                                                _: 1
                                                              }))
                                                            : (_openBlock(), _createBlock(_component_v_icon, { key: 1 }, {
                                                                default: _withCtx(() => _cache[136] || (_cache[136] = [
                                                                  _createTextVNode(" $keyboard_arrow_up ")
                                                                ])),
                                                                _: 1
                                                              }))
                                                        ]),
                                                        _: 1
                                                      })
                                                    ]),
                                                    _: 1
                                                  })
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_expand_transition, null, {
                                        default: _withCtx(() => [
                                          _withDirectives(_createElementVNode("div", null, [
                                            _createVNode(_component_v_row, null, {
                                              default: _withCtx(() => [
                                                (_openBlock(), _createBlock(_component_v_col, { key: _ctx.refreshGeneralLedger25 }, {
                                                  default: _withCtx(() => [
                                                    (_ctx.accountingPeriod)
                                                      ? (_openBlock(), _createBlock(_component_GeneralLedger, {
                                                          key: 0,
                                                          companyId: _ctx.companyId,
                                                          accountingPeriodId: _ctx.accountingPeriod.id,
                                                          accountableAccountFilter: ['25'],
                                                          inNm1: _ctx.showNm1_25,
                                                          onNm1Changed: _cache[47] || (_cache[47] = ($event: any) => (_ctx.showNm1_25 = !_ctx.showNm1_25)),
                                                          onQueryDone: _ctx.onQueryDone25
                                                        }, null, 8, ["companyId", "accountingPeriodId", "inNm1", "onQueryDone"]))
                                                      : _createCommentVNode("", true)
                                                  ]),
                                                  _: 1
                                                }))
                                              ]),
                                              _: 1
                                            })
                                          ], 512), [
                                            [_vShow, _ctx.showGL25]
                                          ])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true),
                              (_ctx.gl26_total || _ctx.gl26_total_filtered)
                                ? (_openBlock(), _createBlock(_component_v_card, {
                                    key: 6,
                                    elevation: "0",
                                    style: {"background-color":"white","border-radius":"25px"},
                                    class: "pa-6 mt-4"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_row, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_col, {
                                            cols: "11",
                                            class: "ma-auto"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_card_title, { class: "ma-0 pa-0" }, {
                                                default: _withCtx(() => [
                                                  _createElementVNode("h5", _hoisted_70, " Participations ou créances rattachées à des participations - c/26 - Solde fin d'exercice " + _toDisplayString(_ctx.newCommonFormatCurrency(_ctx.gl26_total)) + " (dont solde début d'exercice " + _toDisplayString(_ctx.newCommonFormatCurrency(_ctx.gl26_total_filtered)) + " à reprendre) ", 1)
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_v_spacer),
                                          _createVNode(_component_v_col, {
                                            cols: "1",
                                            class: "d-flex align-center justify-center"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_row, null, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_col, { cols: "6" }),
                                                  _createVNode(_component_v_col, {
                                                    cols: "6",
                                                    class: "align-center pa-0"
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_v_btn_icon, {
                                                        icon: _ctx.showGL26 ? '$fa-chevron-up' : '$fa-chevron-down',
                                                        onClick: _cache[48] || (_cache[48] = ($event: any) => (_ctx.showGL26 = !_ctx.showGL26))
                                                      }, null, 8, ["icon"])
                                                    ]),
                                                    _: 1
                                                  })
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_expand_transition, null, {
                                        default: _withCtx(() => [
                                          _withDirectives(_createElementVNode("div", null, [
                                            _createVNode(_component_v_row, null, {
                                              default: _withCtx(() => [
                                                (_openBlock(), _createBlock(_component_v_col, { key: _ctx.refreshGeneralLedger26 }, {
                                                  default: _withCtx(() => [
                                                    (_ctx.accountingPeriod)
                                                      ? (_openBlock(), _createBlock(_component_GeneralLedger, {
                                                          key: 0,
                                                          companyId: _ctx.companyId,
                                                          accountingPeriodId: _ctx.accountingPeriod.id,
                                                          accountableAccountFilter: ['26'],
                                                          inNm1: _ctx.showNm1_26,
                                                          onNm1Changed: _cache[49] || (_cache[49] = ($event: any) => (_ctx.showNm1_26 = !_ctx.showNm1_26)),
                                                          onQueryDone: _ctx.onQueryDone26
                                                        }, null, 8, ["companyId", "accountingPeriodId", "inNm1", "onQueryDone"]))
                                                      : _createCommentVNode("", true)
                                                  ]),
                                                  _: 1
                                                }))
                                              ]),
                                              _: 1
                                            })
                                          ], 512), [
                                            [_vShow, _ctx.showGL26]
                                          ])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true),
                              (_ctx.gl27_total || _ctx.gl27_total_filtered)
                                ? (_openBlock(), _createBlock(_component_v_card, {
                                    key: 7,
                                    elevation: "0",
                                    style: {"background-color":"white","border-radius":"25px"},
                                    class: "pa-6 mt-4"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_row, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_col, {
                                            cols: "11",
                                            class: "ma-auto"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_card_title, { class: "ma-0 pa-0" }, {
                                                default: _withCtx(() => [
                                                  _createElementVNode("h5", _hoisted_71, " Autres immobilisations financières - c/27 - Solde fin d'exercice " + _toDisplayString(_ctx.newCommonFormatCurrency(_ctx.gl27_total)) + " (dont solde début d'exercice " + _toDisplayString(_ctx.newCommonFormatCurrency(_ctx.gl27_total_filtered)) + " à reprendre) ", 1)
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_v_spacer),
                                          _createVNode(_component_v_col, {
                                            cols: "1",
                                            class: "d-flex align-center justify-center"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_row, null, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_col, { cols: "6" }),
                                                  _createVNode(_component_v_col, {
                                                    cols: "6",
                                                    class: "align-center pa-0"
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_v_btn_icon, {
                                                        icon: _ctx.showGL27 ? '$fa-chevron-up' : '$fa-chevron-down',
                                                        onClick: _cache[50] || (_cache[50] = ($event: any) => (_ctx.showGL27 = !_ctx.showGL27))
                                                      }, null, 8, ["icon"])
                                                    ]),
                                                    _: 1
                                                  })
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_expand_transition, null, {
                                        default: _withCtx(() => [
                                          _withDirectives(_createElementVNode("div", null, [
                                            _createVNode(_component_v_row, null, {
                                              default: _withCtx(() => [
                                                (_openBlock(), _createBlock(_component_v_col, { key: _ctx.refreshGeneralLedger27 }, {
                                                  default: _withCtx(() => [
                                                    (_ctx.accountingPeriod)
                                                      ? (_openBlock(), _createBlock(_component_GeneralLedger, {
                                                          key: 0,
                                                          companyId: _ctx.companyId,
                                                          accountingPeriodId: _ctx.accountingPeriod.id,
                                                          accountableAccountFilter: ['27'],
                                                          inNm1: _ctx.showNm1_27,
                                                          onNm1Changed: _cache[51] || (_cache[51] = ($event: any) => (_ctx.showNm1_27 = !_ctx.showNm1_27)),
                                                          onQueryDone: _ctx.onQueryDone27
                                                        }, null, 8, ["companyId", "accountingPeriodId", "inNm1", "onQueryDone"]))
                                                      : _createCommentVNode("", true)
                                                  ]),
                                                  _: 1
                                                }))
                                              ]),
                                              _: 1
                                            })
                                          ], 512), [
                                            [_vShow, _ctx.showGL27]
                                          ])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true)
                            ], 64))
                          : _createCommentVNode("", true),
        (!_ctx.loading && !_ctx.dataLoading)
          ? (_openBlock(), _createBlock(_component_AuditConnectedAcrDocuments, {
              key: 9,
              connectedDocuments: _ctx.connectedDocuments,
              companyId: _ctx.companyId,
              acKey: _ctx.acKey,
              auditCheckResult: _ctx.auditCheckResult || {},
              accountingPeriodId: undefined,
              onUnlinkedDocument: _cache[52] || (_cache[52] = ($event: any) => (_ctx.unlinkDocument($event))),
              onShowLinkedDocument: _cache[53] || (_cache[53] = ($event: any) => (_ctx.showLinkedDocument($event)))
            }, null, 8, ["connectedDocuments", "companyId", "acKey", "auditCheckResult"]))
          : _createCommentVNode("", true),
        (!_ctx.loading && !_ctx.dataLoading && !_ctx.currentPeriodIsFirstPeriod)
          ? (_openBlock(), _createBlock(_component_AuditConnectedAcrResults, {
              key: 10,
              results: _ctx.results,
              companyId: _ctx.companyId
            }, null, 8, ["results", "companyId"]))
          : _createCommentVNode("", true),
        (_ctx.importWizardDialog)
          ? (_openBlock(), _createBlock(_component_CheckFixedAssetsCutPreviousImport, {
              key: 11,
              modelValue: _ctx.importWizardDialog,
              "onUpdate:modelValue": _cache[54] || (_cache[54] = ($event: any) => ((_ctx.importWizardDialog) = $event)),
              onClose: _cache[55] || (_cache[55] = ($event: any) => {
                    _ctx.importLoading = false;
                    _ctx.importWizardDialog = false;
                }),
              title: 'Selectionnez le fichier à importer (.csv, .xlsx, .tsv .txt)',
              onQueryDone: _ctx.onFixedAssetsImported
            }, null, 8, ["modelValue", "onQueryDone"]))
          : _createCommentVNode("", true),
        (_ctx.cutDialog)
          ? (_openBlock(), _createBlock(_component_oss_dialog, {
              key: 12,
              modelValue: _ctx.cutDialog,
              "onUpdate:modelValue": _cache[56] || (_cache[56] = ($event: any) => ((_ctx.cutDialog) = $event)),
              width: "80vw",
              class: "justify-space-around",
              title: "Reprise des immobilisations et amortissements : transformation des écritures\n                        globales en écritures détaillées",
              onValid: _cache[57] || (_cache[57] = ($event: any) => (_ctx.storeCuts())),
              validTitle: "Valider",
              validDisabled: _ctx.disabledStoreCutDocument,
              validLoading: _ctx.storeCutsLoading
            }, {
              default: _withCtx(() => [
                (
                        _ctx.cutDocument &&
                        _ctx.cutDocument.accountingLines &&
                        _ctx.cutDocument.accountingLines.create &&
                        _ctx.cutDocument.accountingLines.create.length
                    )
                  ? (_openBlock(), _createBlock(_component_GetEmptyDocumentsTable, {
                      key: 0,
                      documentAlsCreate: _ctx.cutDocument.accountingLines.create,
                      accountableAccounts: _ctx.storeAccountableAccounts
                    }, null, 8, ["documentAlsCreate", "accountableAccounts"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["modelValue", "validDisabled", "validLoading"]))
          : _createCommentVNode("", true),
        _createVNode(_component_v_card, { class: "pa-6 mt-4" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "5",
                  class: "ma-auto"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card_title, { class: "ma-0 pa-0" }, {
                      default: _withCtx(() => _cache[137] || (_cache[137] = [
                        _createElementVNode("h5", { class: "pl-4" }, "Commentaires détaillés", -1)
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_col, {
                  cols: "1",
                  class: "d-flex align-center justify-center"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                          cols: "6",
                          class: "align-center pa-0"
                        }),
                        _createVNode(_component_v_col, {
                          cols: "6",
                          class: "align-center pa-0"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_btn_icon, {
                              icon: 
                                        _ctx.longCommentExpand ? '$fa-chevron-up' : '$fa-chevron-down'
                                    ,
                              "data-cy": "CheckFixedAssetsCutPrevious-commentairesDetailles",
                              onClick: _cache[58] || (_cache[58] = ($event: any) => (_ctx.longCommentExpand = !_ctx.longCommentExpand)),
                              style: {"width":"40px"},
                              class: "d-inline px-2"
                            }, null, 8, ["icon"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            (_ctx.longCommentExpand)
              ? (_openBlock(), _createBlock(_component_v_card_text, {
                  key: 0,
                  transition: "longCommentExpand"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card_text, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_textarea, {
                          modelValue: _ctx.longComment,
                          "onUpdate:modelValue": _cache[59] || (_cache[59] = ($event: any) => ((_ctx.longComment) = $event)),
                          disabled: _ctx.commentDisabled,
                          "auto-grow": "",
                          style: {"border":"1px #ededed solid"},
                          outlined: ""
                        }, null, 8, ["modelValue", "disabled"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_card_text, { class: "text-end" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_btn, {
                          disabled: _ctx.commentDisabled,
                          rounded: "",
                          onClick: _cache[60] || (_cache[60] = _withModifiers(($event: any) => (_ctx.storeComments()), ["stop"])),
                          size: "small"
                        }, {
                          default: _withCtx(() => _cache[138] || (_cache[138] = [
                            _createTextVNode(" Enregistrer les commentaires ")
                          ])),
                          _: 1
                        }, 8, ["disabled"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_v_card, { class: "pa-6 mt-4" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "5",
                  class: "ma-auto"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card_title, { class: "ma-0 pa-0" }, {
                      default: _withCtx(() => _cache[139] || (_cache[139] = [
                        _createElementVNode("h5", { class: "pl-4" }, "Commentaires synthétiques", -1)
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_col, {
                  cols: "1",
                  class: "d-flex align-center justify-center"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                          cols: "6",
                          class: "align-center pa-0"
                        }),
                        _createVNode(_component_v_col, {
                          cols: "6",
                          class: "align-center pa-0"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_btn_icon, {
                              icon: 
                                        _ctx.shortCommentExpand ? '$fa-chevron-up' : '$fa-chevron-down'
                                    ,
                              "data-cy": "CheckFixedAssetsCutPrevious-commentairesSynthetiques",
                              onClick: _cache[61] || (_cache[61] = ($event: any) => (_ctx.shortCommentExpand = !_ctx.shortCommentExpand)),
                              style: {"width":"40px"},
                              class: "d-inline px-2"
                            }, null, 8, ["icon"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            (_ctx.shortCommentExpand)
              ? (_openBlock(), _createBlock(_component_v_card_text, {
                  key: 0,
                  transition: "shortCommentExpand"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card_text, { class: "px-4" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_textarea, {
                          modelValue: _ctx.shortComment,
                          "onUpdate:modelValue": _cache[62] || (_cache[62] = ($event: any) => ((_ctx.shortComment) = $event)),
                          disabled: _ctx.commentDisabled,
                          "auto-grow": "",
                          style: {"border":"1px #ededed solid"},
                          outlined: ""
                        }, null, 8, ["modelValue", "disabled"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_card_text, { class: "text-end" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_btn, {
                          disabled: _ctx.commentDisabled,
                          rounded: "",
                          onClick: _cache[63] || (_cache[63] = _withModifiers(($event: any) => (_ctx.storeComments()), ["stop"])),
                          size: "small"
                        }, {
                          default: _withCtx(() => _cache[140] || (_cache[140] = [
                            _createTextVNode(" Enregistrer les commentaires ")
                          ])),
                          _: 1
                        }, 8, ["disabled"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        (_ctx.openChat)
          ? (_openBlock(), _createBlock(_component_Chat, {
              key: 13,
              auditCheckAccountingPeriodKey: _ctx.chatId,
              chatTitle: 'Chat'
            }, null, 8, ["auditCheckAccountingPeriodKey"]))
          : _createCommentVNode("", true),
        (_ctx.dialogAuditCheckDocumentsManager)
          ? (_openBlock(), _createBlock(_component_AuditCheckDocumentsManager, {
              key: 14,
              modelValue: _ctx.dialogAuditCheckDocumentsManager,
              "onUpdate:modelValue": _cache[64] || (_cache[64] = ($event: any) => ((_ctx.dialogAuditCheckDocumentsManager) = $event)),
              disabled: _ctx.loading || _ctx.dataLoading,
              companyId: _ctx.companyId,
              documentToDisplay: _ctx.documentToDisplay,
              connectedDocuments: _ctx.connectedDocuments || [],
              acKey: _ctx.acKey,
              auditCheckResult: _ctx.auditCheckResult || {},
              accountingPeriodId: _ctx.accountingPeriodId || undefined,
              alreadyLinkedDoc: _ctx.alreadyLinkedDoc,
              onUpsertedAuditCheckResult: _ctx.upsertedACR,
              onResetDialogData: _cache[65] || (_cache[65] = ($event: any) => {
                    _ctx.alreadyLinkedDoc = false;
                    _ctx.documentToDisplay = {};
                })
            }, null, 8, ["modelValue", "disabled", "companyId", "documentToDisplay", "connectedDocuments", "acKey", "auditCheckResult", "accountingPeriodId", "alreadyLinkedDoc", "onUpsertedAuditCheckResult"]))
          : _createCommentVNode("", true),
        (_ctx.displayActivityDialog)
          ? (_openBlock(), _createBlock(_component_oss_dialog, {
              key: 15,
              modelValue: _ctx.displayActivityDialog,
              "onUpdate:modelValue": _cache[66] || (_cache[66] = ($event: any) => ((_ctx.displayActivityDialog) = $event)),
              title: "Activité",
              "valid-title": "Fermer",
              onValid: _cache[67] || (_cache[67] = ($event: any) => (_ctx.displayActivityDialog = false)),
              onClose: _cache[68] || (_cache[68] = ($event: any) => (_ctx.displayActivityDialog = false)),
              "min-width": "60vw"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_UsersActivitiesHistory, {
                  auditCheckKey: _ctx.acKey,
                  accountingPeriodId: _ctx.accountingPeriodId
                }, null, 8, ["auditCheckKey", "accountingPeriodId"])
              ]),
              _: 1
            }, 8, ["modelValue"]))
          : _createCommentVNode("", true),
        (_ctx.deleteAuditCheckResultDialog)
          ? (_openBlock(), _createBlock(_component_AuditDeleteAuditCheckResultDialog, {
              key: 16,
              modelValue: _ctx.deleteAuditCheckResultDialog,
              "onUpdate:modelValue": _cache[69] || (_cache[69] = ($event: any) => ((_ctx.deleteAuditCheckResultDialog) = $event)),
              auditCheckResultId: _ctx.cutsACRId,
              nestedAuditCheckResults: _ctx.depreciationAcrIds,
              onClosed: _cache[70] || (_cache[70] = ($event: any) => {
                        _ctx.deleteAuditCheckResultLoading = false;
                        _ctx.deleteAuditCheckResultDialog = false;
                    }),
              onDeletedAcr: _ctx.deleteAcrDone
            }, null, 8, ["modelValue", "auditCheckResultId", "nestedAuditCheckResults", "onDeletedAcr"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }))
}